<template>
  <div>
    <Modal :mensagem="erro" @resposta="respConfirm" />
    <b-modal ref="instabilidade" @ok="respostaModalInstabilidade" size="x1" title="Atenção" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <template #modal-header="">
        <h5>Instabilidade</h5>
      </template>
      <p>Identificamos uma instabilidade no sistema no sistema de anexo. Isso pode fazer com que pedidos de protesto que exijam anexo apresentem falhas ou sejam retornados pelo cartório. Nossa equipe já está trabalhando na correção para normalizar o serviço o quanto antes.</p>
    </b-modal>
    <b-modal ref="erroPush" @ok="confirmaErroPush" title="Atenção" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true">
      <p>{{this.erroPushMsg}}</p>
    </b-modal>
    <b-modal
      ref="declaracaoInequivoca"
      title="Atenção"
      :hide-header-close="true"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
    >
      <p>{{ this.erro }}</p>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="success"
            class="float-right"
            @click="confirmarMunicipioDeclaracao(true)"
          >
            Confirmar
          </b-button>
          <b-button variant="danger" class="float-left" @click="confirmarMunicipioDeclaracao(false)">
            Corrigir Dados
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      ref="confirmaSemCertificado"
      size="x1"
      title="Atenção"
      @ok="redirecionaPainel"
      no-close-on-backdrop
      no-close-on-esc
    >
    <template #modal-header="">
      <h5>Atenção</h5>
    </template>
      Para utilizar o serviço de Pedido de Protesto é necessário estar logado por meio de Certificado Digital ICP-Brasil ou niveis Prata ou Ouro via acesso .GOV.BR
    
    </b-modal>

    <b-modal
      ref="modalConfirmaDados"
      size="xl"
      scrollable
      title="Dados do Pedido de Protesto"
    >
      <pdfx
        v-for="i in numPages"
        :key="i"
        :src="pdfConfirma"
        :page="i"
        style="width: 100%; height:1430px; display: inline-block;"

      ></pdfx>
      <!-- v-if="pdfConfirma.length > 0" -->
      
      <p
        v-html="mensagemModalConfirma"
        v-if="mensagemModalConfirma != null"
      ></p>

      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="success"
            class="float-right"
            @click="confirmarDados"
          >
            Confirmar Pedido
          </b-button>
          <b-button variant="danger" class="float-left" @click="corrigirDados">
            Corrigir Dados
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      ref="modalConfirmaDados9430"
      size="xl"
      scrollable
      title="Art. 9A da Lei 9430/96"
    >
      <p v-html="mensagemModalConfirma"></p>

      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="success"
            class="float-right"
            @click="confirmarDados9430"
          >
            Continuar
          </b-button>
          <b-button variant="danger" class="float-left" @click="corrigirDados9430">
            Corrigir Dados
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal ref="modalBoleto" size="xl" scrollable title="Boleto" id="modal-dialog">
      <b-embed type="iframe" aspect="1by1" :src="ds_endereco_boleto"  allowfullscreen v-if="ds_endereco_boleto">
      </b-embed>
    </b-modal>

    <div
      class="text-center"
      v-if="loading"
      style="background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;
        width: 100%;
        height: 100%;
        position: absolute;
        display: block;
        z-index: 10002;
        margin: 0;
        top: 0;
        padding-top: 20%;"
    >
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Text Centered"
      ></b-spinner>
      <br /><span style="color: #004e86">Processando Aguarde...</span>
    </div>
    <div>
      <div
        class="text-center"
        v-if="loading"
        style="
          background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;
          width: 100%;
          height: 100%;
          position: absolute;
          display: block;
          z-index: 10002;
          margin: 0;
          top: 0;
          padding-top: 20%;
        "
      >
        <b-spinner
          variant="primary"
          style="width: 3rem; height: 3rem"
          label="Text Centered"
        ></b-spinner>
        <br /><span style="color: #004e86">Processando Aguarde...</span>
      </div>
      <b-modal
        ref="erro"
        title="Atenção"
        :hide-header-close="true"
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
      >
        <p>{{ this.erro }}</p>
      </b-modal>
      <b-modal
        ref="modalSucesso"
        title="Atenção"
        :hide-header-close="true"
        :no-close-on-esc="true"
        :no-close-on-backdrop="true"
      >
        <p style="white-space: pre-line">{{ this.erro }}</p>

        <template v-slot:modal-footer>
          <div class="w-100">
            <b-button
              variant="success"
              class="float-right"
              @click="incluirTitulos"
            >
              Incluir Titulos
            </b-button>
            <b-button
              variant="primary"
              class="float-left"
              @click="visualizarPedidoProtesto"
            >
              Finalizar
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
    <Header :home="false" :logged="logged" :arealogada="true" />
    <div id="painel" class="container-fluid">
      <b-row>
        <b-col cols="12" md="4" lg="3" v-if="show" style="padding: 0;" class="espaco-menu">
          <Menu class="d-none d-xl-block" />
        </b-col>
        <b-col cols="12" md="8" lg="9" class="flex container-pedidoprotesto" style="padding: 0;">
          <b-container fluid id="painelcontainerfluid">
            <b-row>
              <b-col cols="10" style="padding: 0;">
                <b-breadcrumb :items="breadCrumb"></b-breadcrumb>
              </b-col>
              <b-col cols="2" style="padding: 0.75rem 1rem;" >
                <b-link class="btn-voltar" href="/painel" style="text-decoration:none;font: normal normal 200 16px/24px 'Kanit', sans-serif;color:var(--secondary-color);">
                  Voltar<img src="@/assets/imgs/icons/return-icon.svg" />
                </b-link>
              </b-col>
            </b-row>
            <b-form name="frmProcuracao" id="frmProcuracao">
              <!-- <div class="d-lg-none">
                <button class="mt-4" v-on:click="show = !show">
                  <font-awesome-icon size="1x" icon="bars" />
                </button>
              </div> -->
              <h1 class="text-primary mt-5 text-center">{{form.dados_divida.especie.code === 'CH' ? 'Solicitar envio de cheque a protesto' : 'Solicitar envio de título a protesto'}}</h1>
              <div>
                <b-tabs v-model="tabIndex" content-class="mt-3" align="center" class="ul-ieptb">
                  <b-tab title="01" active>     
                    <div class="mb-4">
                <b-card border-variant="primary-ieptb" header-text-variant="primary-ieptb" class="card-ieptb card-protesto">
                  <template v-slot:header>
                    {{form.dados_divida.especie.code === 'CH' ? 'Dados do Cheque' : 'Informações da Dívida'}}
                    <span
                      v-b-popover.hover.top="
                        'Dados do título ou documento de dívida que esta sendo apresentando a protesto'
                      "
                      title="Informações da Divida"
                      class="infolet"
                    >
                     i
                      <!-- <font-awesome-icon
                        icon="info"
                        mask="circle"
                        size="1x"
                        color="blue"
                      /> -->
                    </span>
                  </template>
                  <b-card-text>
                    <b-row class="mt-2">
                      <b-col cols="12" md="12">
                        <label for="especie">Espécie</label>
                        <v-select
                          id="especie"
                          :disabled="!(estados.length>0)"
                          v-model="form.dados_divida.especie"
                          :options="especies"
                          :state="validations.dados_divida_especie"
                          @input="onChangeEspecie"
                          required
                        ></v-select>
                        <b-form-invalid-feedback
                          :state="validations.dados_divida_especie"
                        >
                          Informe a Espécie.
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <b-row
                      class="mt-2"
                      v-if="form.dados_divida.especie.code == 'CH'"
                    >
                      <b-col cols="12" md="12">
                        <label for="justificativa_cheque"
                          >Justificativa da devolução do cheque</label
                        >
                        <b-form-textarea
                          rows="3"
                          v-model.trim="form.dados_divida.justificativa_cheque"
                          no-resize
                          :state="
                            form.dados_divida.justificativa_cheque.length >= 10
                          "
                          maxlength="80"
                          placeholder="Indique a justificativa da devolução do cheque. (No mínimo 10 caracteres, no máximo, 80)"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                          :state="
                            form.dados_divida.justificativa_cheque.length >= 10
                          "
                          >Justificativa não possui o tamanho
                          requerido</b-form-invalid-feedback
                        >
                        <b-form-text
                          v-show="
                            form.dados_divida.justificativa_cheque.length >= 10
                          "
                          id="helpJustificativaCheque"
                        >
                          Máximo de 80 caracteres. ({{
                            80 - form.dados_divida.justificativa_cheque.length
                          }}
                          restantes)
                        </b-form-text>
                      </b-col>
                    </b-row>
                    <b-row v-if="['NP','NPR','CH'].includes(form.dados_divida.especie.code)">
                      <b-col cols="12" md="12" lg="12">
                        <h6 class="text-primary mt-5">Praça de Protesto</h6>
                      </b-col>
                    </b-row>
                    <b-row
                      class="mt-2"
                      v-if="['NP','NPR','CH'].includes(form.dados_divida.especie.code)"
                    >
                      <b-col cols="2" md="2">
                        <label for="NP_UF">UF</label>
                        <b-select
                          v-model="form.np_cd_uf"
                          :options="estados"
                          :state="validations.np_cd_uf"
                          required
                        ></b-select>
                        <div class="select-arrow-down"></div>
                        <b-form-invalid-feedback
                          :state="validations.np_cd_uf"
                        >
                          Informe a UF .
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col cols="6" md="6">
                        <label for="NP_UF">Cidade</label>
                        <v-select
                          v-model="form.np_cd_ibge"
                          :options="municipiosNP"
                          :state="validations.np_cd_ibge"
                        ></v-select>
                        <b-form-invalid-feedback
                          :state="validations.np_cd_ibge"
                        >
                          Informe a Cidade .
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <b-row v-if="form.dados_divida.especie.code == 'NP' || form.dados_divida.especie.code == 'CH'">
                      <b-col cols="12" md="12" lg="12">
                        <hr />
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6">
                        <label for="dados_divida_numero">Número</label>
                        <b-input
                          v-model="form.dados_divida.numero"
                          maxlength="11"
                          placeholder="Número"
                          :state="validations.dados_divida_numero"
                          @keypress="preencheNossoNumero()"
                          required
                        ></b-input>
                        <b-form-invalid-feedback
                          :state="validations.dados_divida_numero"
                        >
                          Infome o número.
                        </b-form-invalid-feedback>
                      </b-col>
                      <!-- <b-col cols="12" md="3">
                        <label for="nosso_numero">Nosso Número</label>
                        <b-input
                          placeholder="Nosso Número"
                          v-model="form.dados_divida.nosso_numero"
                          :state="validations.dados_divida_nosso_numero"
                          maxlength="15"
                          required
                        >
                        </b-input>
                        <b-form-invalid-feedback
                          :state="validations.dados_divida_nosso_numero"
                        >
                          Infome o Nosso Número.
                        </b-form-invalid-feedback>
                      </b-col> -->
                      <b-col cols="12" md="3">
                        <label for="nosso_numero">Data Emissão</label>
                        <b-input
                          v-model="form.dados_divida.dt_emissao"
                          :state="validations.dados_divida_dt_emissao"
                          type="date"
                          maxlength="10"
                          :max="maxDate"
                          :min="minDate"
                          required
                        >
                        </b-input>
                        <b-form-invalid-feedback
                          :state="validations.dados_divida_dt_emissao"
                        >
                          Data Emissão informada é inválida.
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col cols="12" md="3">
                        <label for="nosso_numero">Data Vencimento</label>
                        <b-input
                          v-model="form.dados_divida.dt_vencimento"
                          :state="validations.dados_divida_dt_vencimento"
                          type="date"
                          maxlength="10"
                          :max="maxDate"
                          :min="minDate"
                          required
                        >
                        </b-input>
                        <b-form-invalid-feedback
                          :state="validations.dados_divida_dt_vencimento"
                        >
                          Informe a Data Vencimento menor que hoje e maior que a data de emissão.
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <!-- <b-row>
                              <b-col cols="12" md="12" lg="12" >
                               
                                <hr>
                              </b-col>
                            </b-row>
                            -->
                    
                    <b-row class="mt-2">
                      <b-col cols="12" md="4" lg="4">
                        <label for="endosso">
                          Endosso &nbsp;&nbsp;&nbsp;
                          <span id="pop_endosso">
                            <font-awesome-icon
                              icon="info"
                              mask="circle"
                              size="1x"
                              color="blue"
                            />
                          </span>
                          <b-popover
                            target="pop_endosso"
                            triggers="hover"
                            placement="top"
                          >
                            <template v-slot:title>Endosso</template>
                            Declaração que transmite ordens ao título ou
                            documento de dívida. Refere-se a relação entre
                            Apresentante e Sacador.
                            <p>
                              &nbsp; 1) Translativo: Transfere o crédito do
                              título ou documento de dívida do Sacador ao
                              Apresentante.
                            </p>
                            <p>
                              &nbsp; 2) Mandato: Autoriza o Apresentante a
                              enviar ou receber créditos de títulos ou
                              documentos de dívida.
                            </p>
                            <p>
                              &nbsp; 3)Sem Endosso: Apresentante / Sacador são a
                              mesma pessoa, não havendo autorização de poderes.
                            </p>
                          </b-popover>
                        </label>
                        <b-select
                          id="endosso"
                          v-model="form.dados_divida.endosso"
                          :options="endosso"
                          @change="alteraEndosso()"
                          required
                        ></b-select>
                        <div class="select-arrow-down"></div>
                      </b-col>
                      <b-col cols="12" md="4" lg="4" v-if="listAceiteDeclaracao.indexOf(form.dados_divida.especie.code) > -1 ">
                        <label>
                          Aceite &nbsp;&nbsp;&nbsp;
                          <span
                            v-b-popover.hover.top="
                              'Ato pelo qual o devedor reconhece formalmente a dívida do título ou documento de dívida emitido.'
                            "
                            title="Aceite"
                          >
                            <font-awesome-icon
                              icon="info"
                              mask="circle"
                              size="1x"
                              color="blue"
                            />
                          </span>
                        </label>
                        <b-select
                          v-model="form.dados_divida.aceite"
                          :options="aceite"
                          required
                        ></b-select>
                        <div class="select-arrow-down"></div>
                      </b-col>
                      <!-- <b-col cols="12" md="3" lg="3">
                        <label>
                          Fins Falimentares &nbsp;&nbsp;&nbsp;
                          <span
                            v-b-popover.hover.top="
                              'Protesto por motivo de falência'
                            "
                            title="Fins Falimentares"
                          >
                            <font-awesome-icon
                              icon="info"
                              mask="circle"
                              size="1x"
                              color="blue"
                            />
                          </span>
                        </label>
                        <b-select
                          v-model="form.dados_divida.finsFalimentares"
                          :options="finsFalimentares"
                          :state="validations.dados_divida_especie"
                          required
                          @change="alteraFinsFalimentares()"
                        ></b-select>
                        <b-form-invalid-feedback
                          :state="validations.dados_divida_endosso"
                        >
                          Endereço inválido.
                        </b-form-invalid-feedback>
                      </b-col> -->

                      <!-- <b-col cols="12" md="3" lg="3">
                        <label>Declaração do Portador</label>
                        <b-select
                          v-model="form.dados_divida.declaracao_portador"
                          :options="declaracoes_portador"
                          disabled
                        ></b-select>
                        <div class="select-arrow-down"></div>
                      </b-col> -->
                      <b-col cols="12" md="4" lg="4">
                        <label>
                          Tipo de Protesto
                          &nbsp;&nbsp;&nbsp;
                          <span id="pop_finalidade_pedido">
                            <font-awesome-icon
                              icon="info"
                              mask="circle"
                              size="1x"
                              color="blue"
                            />
                          </span>
                          <b-popover
                            target="pop_finalidade_pedido"
                            triggers="hover"
                            placement="top"
                          >
                            <template v-slot:title
                              >Tipo de Protesto</template
                            >
                            <p>
                              <b>Comum - </b>
                              O protesto de títulos que ocorre de acordo com as normas gerais estabelecidas pela Lei nº 9.492/97, tem como objetivo garantir a segurança e a eficácia do processo de cobrança de dívidas.
                              
                              <br><br>
                              <b>Fins Fiscais - </b>

                              Se você for pessoa jurídica tributada com base no lucro real, e desejar registrar como perda este crédito, conforme o art. 9º-A da Lei 9.430/96, selecione esta opção.
                              <br><br>
                              <b>Fins Falimentares - </b>
                              Protesto por motivo de falência
                              <br><br>
                              <b>Solução Negocial Prévia - </b>
                              Opção baseada na Lei nº 14.711/23 que permite a tentativa de conciliação e mediação incentivada pelo Tabelião antes da efetivação do protesto, visando a regularização da dívida de forma célere e menos burocrática.
                            </p>
                          </b-popover>

                        </label>
                        
                        <b-select
                          v-model="tipo_de_protesto"
                          :options="tipo_protesto"
                          :disabled="bloqueio9430"
                          @change="exibeModalPergunta"
                        ></b-select>
                        <div class="select-arrow-down"></div>
                      </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col cols="12" md="3">
                        <label for="valorTitulo"
                          >{{form.dados_divida.especie.code === 'CH' ? 'Valor do Cheque' : 'Valor do Titulo'}}</label
                        >
                        <b-form-input
                          id="valorTitulo"
                          v-model="form.dados_divida.valor"
                          placeholder="R$ 0,00"
                          @keyup="moeda"
                          maxlength="19"
                          :state="validations.dados_divida_valor"
                        ></b-form-input>
                        <b-form-invalid-feedback
                          :state="validations.dados_divida_valor"
                        >
                          {{form.dados_divida.especie.code === 'CH' ? 'Preencha o Valor do Cheque.' : 'Preencha o Valor do Título.'}}
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col cols="12" md="3">
                        <label for="valorProtestado"
                          >Valor a Protestar</label
                        >
                        <b-form-input
                          id="valorProtestado"
                          v-model="form.dados_divida.saldo"
                          placeholder="R$ 0,00"
                          @keyup="moeda"
                          maxlength="19"
                          :state="validations.dados_divida_saldo"
                        ></b-form-input>
                        <b-form-invalid-feedback
                          :state="validations.dados_divida_saldo"
                        >
                          Preencha o Valor a Protestar.
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col cols="12" md="6">
                        <label for="files">
                          Anexo &nbsp;&nbsp;&nbsp;
                          <span
                            v-b-popover.hover.top="
                              'Para adicionar multiplos arquivos, utilize a extensão ZIP'
                            "
                            title="Arquivo Anexo"
                          >
                            <font-awesome-icon
                              icon="info"
                              mask="circle"
                              size="1x"
                              color="blue"
                            />
                          </span>
                        </label>
                        <b-form-file
                          id="files"
                          ref="file-input"
                          @change="anexar"
                          placeholder="Escolha um arquivo"
                          drop-placeholder="Solte o arquivo."
                          accept=".pdf, .xls, .xlsx, .p7s, .zip"
                          browse-text="Buscar"
                          :state="validations.dados_divida_anexo"
                          :disabled="desabilita_anexo"
                        ></b-form-file>
                        <div id="progress_bar" class="esconder">
                          <div id="percent" class="percent" style="width: 0px">0%</div>
                          <font-awesome-icon
                              icon="trash"
                              size="1x"
                              color="red"
                              @click="excluirAnexo"
                            />
                        </div>
                        <b-form-invalid-feedback
                          :state="validations.dados_divida_anexo"
                        >
                          Essa Espécie requer um anexo.
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-alert variant="warning" show class="mt-4"
                          >Atenção, no campo <b>Anexo</b> será permitido apenas
                          arquivos do tipo <b>PDF, P7S, XLS, ZIP</b></b-alert
                        >
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>
              <div class="mt-4" >
                <b-card border-variant="primary-ieptb" header-text-variant="primary-ieptb" :header="form.dados_divida.especie.code === 'CH' ? 'Informações do Endossatário' : 'Informações do Credor Atual'" class="card-ieptb">
                  <template v-slot:header>
                    {{form.dados_divida.especie.code === 'CH' ? 'Informações do Endossatário' : 'Informações do Credor Atual'}}
                    <span
                      v-b-popover.hover.top="
                        'Pessoa Física ou Jurídica que vai receber o pagamento pelo título ou documento de dívida.'
                      "
                      title="Cedente"
                      class="infolet"
                    >
                    i
                      <!-- <font-awesome-icon
                        icon="info"
                        mask="circle"
                        size="1x"
                        color="blue"
                      /> -->
                    </span>
                  </template>
                  <b-card-text>
                    <b-row>
                      <b-col cols="12" md="4" lg="4" >
                        <label for="documento_cedente">CPF/CNPJ:</label>
                        <b-input
                          id="documento_cedente"
                          v-model="form.documento_cedente"
                          placeholder="Documento"
                          maxlength="18"
                          :state="validations.documento_cedente"
                          person="cedente"
                          @blur="validarDocumento('validations.documento_cedente', $event)"
                          :formatter="documento" 
                          :disabled="travaCedente"
                          >
                        </b-input>
                        <b-form-invalid-feedback :state="validations.documento_cedente">
                            Infome um documento válido.
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col cols="12" md="4" lg="8">
                        <label for="nome_solicitante">Nome completo:</label>
                        <b-input
                          v-model="form.nome_cedente"
                          maxlength="45"
                          placeholder="Nome"
                          :state="validations.nome_cedente"
                          :disabled="travaCedente"
                          id="cedente_nome"
                          required
                        ></b-input>
                        <b-form-invalid-feedback
                          :state="validations.nome_cedente"
                        >
                          Infome o nome.
                        </b-form-invalid-feedback>
                      </b-col>
                      
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="12" lg="12">
                        <hr />
                        <h4 class="text-primary mt-5">Endereço:</h4>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="3">
                        <label for="endereco_cedente_cep">CEP:</label>
                        <b-input
                          v-model="cedente_cep"
                          maxlength="9"
                          type="text"
                          placeholder="_____-___"
                          :formatter="cep"
                          id="endereco_cedente_cep"
                          :disabled="travaCedente"
                        ></b-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6">
                        <label for="cedente_logradouro">Logradouro:</label>
                        <b-input
                          v-model="form.endereco_cedente.logradouro"
                          maxlength="30"
                          type="text"
                          placeholder="logradouro"
                          id="cedente_logradouro"
                          @blur="formataEndereco('cedente')"
                          :disabled="travaCedente"
                        ></b-input>
                      </b-col>
                      <b-col cols="12" md="6">
                        <label for="cedente_numero">Número:</label>
                        <b-input
                          v-model="form.endereco_cedente.numero"
                          maxlength="5"
                          type="text"
                          placeholder="Numero"
                          id="cedente_numero"
                          @blur="formataEndereco('cedente')"
                          :disabled="travaCedente"
                        ></b-input>
                      </b-col>
                      <b-col cols="12" md="6">
                        <label for="cedente_complemento">Complemento: <i>(Opcional)</i></label>
                        <b-input
                          v-model="form.endereco_cedente.complemento"
                          maxlength="10"
                          type="text"
                          placeholder="Complemento"
                          id="cedente_complemento"
                          @blur="formataEndereco('cedente')"
                          :disabled="travaCedente"
                        ></b-input>
                      </b-col>
                      <!-- <b-col cols="12" md="6">
                        <label for="cedente_endereco">Endereço:</label>
                        <b-input
                          v-model="form.endereco_cedente.endereco"
                          maxlength="45"
                          type="text"
                          placeholder="Endereço"
                          id="cedente_endereco"
                          :disabled="travaCedente"
                        ></b-input>
                      </b-col> -->
                      <b-col cols="12" md="6">
                        <label for="cedente_bairro">Bairro:</label>
                        <b-input
                          v-model="form.endereco_cedente.bairro"
                          maxlength="20"
                          type="text"
                          placeholder="Bairro"
                          id="cedente_bairro"
                          :disabled="travaCedente"
                        ></b-input>
                      </b-col>
                      <b-col cols="12" md="6">
                        <label for="cedente_cidade">Cidade:</label>
                        <b-input
                          v-model="form.endereco_cedente.cidade"
                          maxlength="20"
                          type="text"
                          placeholder="Cidade"
                          id="cedente_cidade"
                          :disabled="travaCedente"
                        ></b-input>
                      </b-col>
                      <b-col cols="12" md="6">
                        <label for="cedente_uf">UF:</label>
                        <b-select
                          v-model="form.endereco_cedente.cd_uf"
                          :options="estados"
                          :disabled="travaCedente"
                        ></b-select>
                        <div class="select-arrow-down"></div>
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>         
              <div v-if="['1','2'].includes(form.dados_divida.endosso)">
                <b-card
                  border-variant="primary-ieptb"
                  header-text-variant="primary-ieptb"
                  :header="form.dados_divida.especie.code === 'CH' ? 'Informações do Endossante' : 'Informações do Credor Original'"
                  color="red"
                  class="card-ieptb"
                >
                  <template v-slot:header>
                    {{form.dados_divida.especie.code === 'CH' ? 'Informações do Endossante' : 'Informações do Credor Original'}}
                    <span
                      v-b-popover.hover.top="
                        'Pessoa Física ou Jurídica que emitiu o título ou documento de dívida'
                      "
                      title="Informar o Credor"
                      class="infolet"
                    >
                    i
                      <!-- <font-awesome-icon
                        icon="info"
                        mask="circle"
                        size="1x"
                        color="blue"
                      /> -->
                    </span>
                  </template>
                  <b-card-text>
                    <b-row>
                      <b-col cols="12" md="4" lg="4">
                        <label for="documento_sacador">CPF/CNPJ:</label>
                        <b-input
                          id="documento_sacador"
                          v-model="form.documento_sacador"
                          placeholder="Documento"
                          maxlength="18"
                          :state="validations.documento_sacador"
                          person="sacador"
                          @blur="
                            validarDocumento(
                              'validations.documento_sacador',
                              $event
                            )
                          "
                          :formatter="documento"
                          required
                        >
                        </b-input>
                        <b-form-invalid-feedback
                          :state="validations.documento_sacador"
                        >
                          Infome um documento válido.
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col cols="12" md="4" lg="8">
                        <label for="nome_solicitante">Nome completo:</label>
                        <b-input
                          v-model="form.nome_sacador"
                          maxlength="45"
                          placeholder="Nome"
                          :state="validations.nome_sacador"
                          id="sacador_nome"
                          required
                        ></b-input>
                        <b-form-invalid-feedback
                          :state="validations.nome_sacador"
                        >
                          Infome o nome.
                        </b-form-invalid-feedback>
                      </b-col>
                      
                    </b-row>
                    <b-row class="mt-2">
                      
                      <b-col cols="12" md="8">
                        <label for="email_sacador">E-mail:</label>
                        <b-input
                          v-model="form.email_sacador"
                          placeholder="email"
                          maxlength="50"
                          :state="validations.email_sacador"
                          required
                        >
                        </b-input>
                        <b-form-invalid-feedback
                          :state="validations.email_sacador"
                        >
                          E-mail inválido.
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col cols="12" md="4">
                        <label for="nome_solicitante">Contato:</label>
                        <b-input
                          v-model="form.celular_sacador"
                          :formatter="Celular"
                          :state="validations.celular_sacador"
                          maxlength="15"
                          placeholder="(XX) 9123-4567"
                        ></b-input>
                        <b-form-invalid-feedback
                          :state="validations.celular_sacador"
                        >
                          Celular inválido.
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="12" lg="12">
                        <hr />
                        <h4 class="text-primary mt-5">Endereço</h4>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="3" lg="3">
                        <label for="sacador_cep">CEP:</label>
                        <b-input
                          v-model="sacador_cep"
                          maxlength="9"
                          type="text"
                          placeholder="_____-___"
                          :state="validations.endereco_sacador_cep"
                          :formatter="cep"
                          id="sacador_cep"
                          required
                        ></b-input>
                        <b-form-invalid-feedback
                          :state="validations.endereco_sacador_cep"
                        >
                          CEP inválido.
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6">
                        <label for="sacador_logradouro">Logradouro:</label>
                        <b-input
                          v-model="form.endereco_sacador.logradouro"
                          maxlength="30"
                          type="text"
                          placeholder="Logradouro"
                          id="sacador_logradouro"
                          @blur="formataEndereco('sacador')"
                          :state="validations.endereco_sacador_endereco_logradouro"
                          required
                        ></b-input>
                        <b-form-invalid-feedback
                          :state="validations.endereco_sacador_endereco_logradouro"
                        >
                          Logradouro inválido.
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col cols="12" md="6">
                        <label for="sacador_numero">Número:</label>
                        <b-input
                          v-model="form.endereco_sacador.numero"
                          maxlength="5"
                          type="text"
                          placeholder="Número"
                          id="sacador_numero"
                          @blur="formataEndereco('sacador')"
                          :state="validations.endereco_sacador_endereco_numero"
                          required
                        ></b-input>
                        <b-form-invalid-feedback
                          :state="validations.endereco_sacador_endereco_numero"
                        >
                          Número do endereço inválido.
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col cols="12" md="6">
                        <label for="sacador_complemento">Complemento: <i>(Opcional)</i></label>
                        <b-input
                          v-model="form.endereco_sacador.complemento"
                          maxlength="10"
                          type="text"
                          placeholder="Complemento"
                          id="sacador_complemento"
                          @blur="formataEndereco('sacador')"
                        ></b-input>
                      </b-col>
                      <!-- <b-col cols="12" md="6">
                        <label for="outorgante_endereco">Endereço:</label>
                        <b-input
                          v-model="form.endereco_sacador.endereco"
                          maxlength="45"
                          type="text"
                          placeholder="Endereço"
                          :state="validations.sacador_endereco"
                          required
                        ></b-input>
                        <b-form-invalid-feedback
                          :state="validations.sacador_endereco"
                        >
                          Endereço inválido.
                        </b-form-invalid-feedback>
                      </b-col> -->
                      <b-col cols="12" md="6">
                        <label for="sacador_bairro">Bairro:</label>
                        <b-input
                          v-model="form.endereco_sacador.bairro"
                          maxlength="20"
                          type="text"
                          placeholder="Bairro"
                          :state="validations.sacador_bairro"
                          id="sacador_bairro"
                          required
                        ></b-input>
                        <b-form-invalid-feedback
                          :state="validations.sacador_bairro"
                        >
                          Informe o Bairro.
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col cols="12" md="6">
                        <label for="sacador_cidade">Cidade:</label>
                        <b-input
                          v-model="form.endereco_sacador.cidade"
                          maxlength="20"
                          type="text"
                          placeholder="Cidade"
                          :state="validations.sacador_cidade"
                          id="sacador_cidade"
                          disabled
                          required
                        ></b-input>
                        <b-form-invalid-feedback
                          :state="validations.sacador_cidade"
                        >
                          Informe a Cidade.
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col cols="12" md="6">
                        <label for="sacador_uf">UF:</label>
                        <b-select
                          id="sacador_uf"
                          v-model="form.endereco_sacador.cd_uf"
                          :options="estados"
                          :state="validations.sacador_uf"
                          disabled
                          required
                        ></b-select>
                        <div class="select-arrow-down"></div>
                        <b-form-invalid-feedback
                          :state="validations.sacador_uf"
                        >
                          Informe a UF .
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>
              <div class="mt-4">
                <b-card border-variant="primary-ieptb" header-text-variant="primary-ieptb" class="card-ieptb">
                  <template v-slot:header>
                    {{form.dados_divida.especie.code === 'CH' ? 'Informações do Emitente' : 'Informações do Devedor'}}
                    <span
                      v-b-popover.hover.top="
                        'Pessoa Física ou Jurídica responsável pelo pagamento do título ou documento de dívida.'
                      "
                      title="Devedor"
                      class="infolet"
                    >
                    i
                      <!-- <font-awesome-icon
                        icon="info"
                        mask="circle"
                        size="1x"
                        color="blue"
                      /> -->
                    </span>
                  </template>
                  <b-card-text>
                    <b-row>
                      <b-col cols="12" md="4" lg="4">
                        <label for="documento_devedor">CPF/CNPJ:</label>
                        <b-input
                          id="documento_devedor"
                          v-model="form.documento_devedor"
                          placeholder="Documento"
                          maxlength="18"
                          :state="validations.documento_devedor"
                          person="devedor"
                          @blur="
                            validarDocumento(
                              'validations.documento_devedor',
                              $event
                            )
                          "
                          :formatter="documento"
                          required
                        >
                        </b-input>
                        <b-form-invalid-feedback
                          :state="validations.documento_devedor"
                        >
                          Infome um documento válido.
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col cols="12" md="4" lg="8">
                        <label for="nome_devedor">Nome:</label>
                        <b-input
                          v-model="form.nome_devedor"
                          maxlength="45"
                          placeholder="Nome"
                          :state="validations.nome_devedor"
                          id="nome_devedor"
                          required
                        ></b-input>
                        <b-form-invalid-feedback
                          :state="validations.nome_devedor"
                        >
                          Infome o nome.
                        </b-form-invalid-feedback>
                      </b-col>
                      
                    </b-row>
                    <b-row class="mt-2">
                      
                      <b-col cols="12" md="8">
                        <label for="email_devedor">E-mail:</label>
                        <b-input
                          v-model="form.email_devedor"
                          placeholder="email"
                          maxlength="50"
                          :state="optionalValidations.email_devedor"
                          @blur="validateEmail($event, 'optionalValidations.email_devedor')"
                        >
                        </b-input>
                        <b-form-invalid-feedback
                          :state="optionalValidations.email_devedor"
                        >
                          E-mail inválido.
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col cols="12" md="4">
                        <label for="celular_devedor">Contato:</label>
                        <b-input
                          v-model="form.celular_devedor"
                          :formatter="Celular"
                          maxlength="15"
                          placeholder="(XX) 9123-4567"
                        ></b-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="12" lg="12">
                        <hr />
                        <h4 class="text-primary mt-5">Endereço:</h4>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="12" md="3" lg="3">
                        <label for="devedor_cep">CEP:</label>
                        <b-input
                          v-model="devedor_cep"
                          maxlength="9"
                          type="text"
                          placeholder="_____-___"
                          :state="validations.endereco_devedor_cep"
                          :formatter="cep"
                          id="devedor_cep"
                          required
                        ></b-input>
                        <b-form-invalid-feedback
                          :state="validations.endereco_devedor_cep"
                        >
                          CEP inválido.
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6">
                        <label for="endereco_devedor_logradouro">Logradouro:</label>
                        <b-input
                          v-model="form.endereco_devedor.logradouro"
                          maxlength="30"
                          type="text"
                          placeholder="Logradouro"
                          id="endereco_devedor_logradouro"
                          @blur="formataEndereco('devedor')"
                          :state="validations.endereco_devedor_endereco_logradouro"
                          required
                        ></b-input>
                        <b-form-invalid-feedback
                          :state="validations.endereco_devedor_endereco_logradouro"
                        >
                          Logradouro inválido.
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col cols="12" md="6">
                        <label for="endereco_devedor_numero">Número:</label>
                        <b-input
                          v-model="form.endereco_devedor.numero"
                          maxlength="5"
                          type="text"
                          placeholder="Número"
                          id="endereco_devedor_numero"
                          @blur="formataEndereco('devedor')"
                          :state="validations.endereco_devedor_endereco_numero"
                          required
                        ></b-input>
                        <b-form-invalid-feedback
                          :state="validations.endereco_devedor_endereco_numero"
                        >
                          Número do endereço inválido.
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col cols="12" md="6">
                        <label for="devedor_complemento">Complemento: <i>(Opcional)</i></label>
                        <b-input
                          v-model="form.endereco_devedor.complemento"
                          maxlength="10"
                          type="text"
                          placeholder="Complemento"
                          id="devedor_complemento"
                          @blur="formataEndereco('devedor')"
                        ></b-input>
                      </b-col>
                      <!-- <b-col cols="12" md="6">
                        <label for="outorgante_endereco">Endereço:</label>
                        <b-input
                          v-model="form.endereco_devedor.endereco"
                          maxlength="45"
                          type="text"
                          placeholder="Endereço"
                          :state="validations.endereco_devedor_endereco"
                          required
                        ></b-input>
                        <b-form-invalid-feedback
                          :state="validations.endereco_devedor_endereco"
                        >
                          Endereço inválido.
                        </b-form-invalid-feedback>
                      </b-col> -->
                      <b-col cols="12" md="6">
                        <label for="devedor_bairro">Bairro:</label>
                        <b-input
                          v-model="form.endereco_devedor.bairro"
                          maxlength="20"
                          type="text"
                          placeholder="Bairro"
                          :state="validations.endereco_devedor_bairro"
                          id="devedor_bairro"
                          required
                        ></b-input>
                        <b-form-invalid-feedback
                          :state="validations.endereco_devedor_bairro"
                        >
                          Informe o Bairro.
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col cols="12" md="6">
                        <label for="devedor_cidade">Cidade:</label>
                        <b-input
                          v-model="form.endereco_devedor.cidade"
                          maxlength="20"
                          type="text"
                          placeholder="Cidade"
                          :state="validations.endereco_devedor_cidade"
                          id="devedor_cidade"
                          :disabled="endereco_devedor_cidade_disabled"
                          required
                        ></b-input>
                        <b-form-invalid-feedback
                          :state="validations.endereco_devedor_cidade"
                        >
                          Informe a Cidade.
                        </b-form-invalid-feedback>
                      </b-col>
                      <b-col cols="12" md="6">
                        <label for="devedor_uf">UF:</label>
                        <b-select
                          id="devedor_uf"
                          v-model="form.endereco_devedor.cd_uf"
                          :options="estados"
                          :state="validations.endereco_devedor_uf"
                          :disabled="endereco_devedor_uf_disabled"
                          required
                        ></b-select>
                        <div class="select-arrow-down"></div>
                        <b-form-invalid-feedback
                          :state="validations.endereco_devedor_uf"
                        >
                          Informe a UF .
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <template v-if="['CTI'].includes(form.dados_divida.especie.code)">
                      <b-row>
                        <b-col cols="12" md="12" lg="12">
                          <hr />
                          <h4 class="text-primary mt-5">Praça de Protesto:</h4>
                        </b-col>
                      </b-row>
                      <b-row >
                        <b-col cols="2" md="2">
                          <label for="NP_UF">UF</label>
                          <b-select
                            v-model="form.np_cd_uf"
                            :options="estados"
                            :state="validations.np_cd_uf"
                            :disabled="!isFieldSet(form.endereco_devedor.cd_uf) && !isFieldSet(form.endereco_devedor.cidade)"
                            required
                          ></b-select>
                          <div class="select-arrow-down"></div>
                          <b-form-invalid-feedback :state="validations.np_cd_uf">Informe a UF.</b-form-invalid-feedback>
                        </b-col>
                        <b-col cols="6" md="6">
                          <label for="NP_UF">Cidade</label>
                          <b-select
                            :disabled="!isFieldSet(form.endereco_devedor.cd_uf) && !isFieldSet(form.endereco_devedor.cidade)"
                            v-model="form.np_cd_ibge"
                            :options="municipiosNP"
                            :state="validations.np_cd_ibge"
                            required
                          ></b-select>
                          <div class="select-arrow-down"></div>
                          <b-form-invalid-feedback :state="validations.np_cd_ibge" > Informe a Cidade .</b-form-invalid-feedback>
                        </b-col>
                      </b-row>
                    </template>
                    <b-row>
                      <b-col cols="12" md="5" class="mt-4" v-if="totalCodevedor < 8 && form.dados_divida.especie.code != 'DMI'">
                        <label><b-button variant="primary" class="btn-adicionar-codevedor" @click="adicionarCodevedor()"> {{form.dados_divida.especie.code === 'CH' ? 'Adicionar Co-emitente' : 'Adicionar Codevedor'}} <font-awesome-icon icon="plus"/></b-button></label>
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>
              <codevedor :codevedores="aCodevedor" :estados="estados" :docDevedor="form.documento_devedor" :docSacador="form.documento_sacador" :docCedente="form.documento_cedente" :especie="form.dados_divida.especie.code"
               @removecodevedor="removerCodevedor" @atualizaCodevedores="attCodevedores" @autalizaBloqueio="updateBloqueio9430"  @errorCodevedor="showError"/>
              
              <br />
              
              <div>
                <br />
                <b-row>
                  <!-- <b-col cols="10" md="10" lg="10"></b-col> -->
                  <b-col cols="12" md="12" lg="12" class="float-right">
                    <b-button
                      block
                      class="float-right btn-prosseguir"
                      variant="primary"
                      type="button"
                      :disabled=this.desabilidar
                      @click="gerar"
                      >Prosseguir</b-button
                    >
                  </b-col>
                </b-row>
                <br /><br /><br /><br />
              </div>
              </b-tab>
                <b-tab title="02" class="tab2-protesto">
                  <b-card
                    border-variant="primary-ieptb"
                    header-text-variant="primary-ieptb"
                    header="Confira so dados"
                    color="red"
                    class="card-ieptb"
                  >
                  <template v-slot:header>
                    Confira os dados
                  </template>
                  <b-card-text>
                    <b-row>
                      <b-col cols="12" md="6" lg="6"><h4 class="text-primary mt-2">Solicitação de protesto</h4></b-col>
                      <b-col cols="12" md="6" lg="6"></b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="12" lg="12"><h5 class="mt-5">Dados do Apresentante</h5><hr></b-col>                      
                    </b-row>

                    <b-row>
                      <b-col cols="12" md="6" lg="6">
                        <label  class="conferencia_dados_label"><b>Nome: </b>{{form.nome_apresentante}}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="6">
                        <label  class="conferencia_dados_label float-right"><b>Documento: </b>{{form.documento_apresentante}}</label>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6" lg="6">
                        <label  class="conferencia_dados_label"><b>Email: </b>{{form.email_apresentante}}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="6">
                        <label class="conferencia_dados_label float-right"><b>Celular: </b>{{form.celular_apresentante}}</label>
                      </b-col>
                    </b-row>
                    
                    <b-row>                    
                      <b-col cols="12" md="6" lg="6">
                        <label class="conferencia_dados_label"><b>Endereço: </b>{{form.endereco_apresentante.endereco}}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="6">
                        <label class="conferencia_dados_label float-right"><b> UF: </b> {{form.endereco_apresentante.uf}}</label>
                      </b-col>
                    </b-row>

                    <b-row> 
                      <b-col cols="12" md="6" lg="6">
                        <label class="conferencia_dados_label"><b>Cidade: </b> {{form.endereco_apresentante.cidade}}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="6">
                        <label class="conferencia_dados_label float-right"><b>CEP: </b>{{form.endereco_apresentante.cep}}</label>
                      </b-col>
                    </b-row>
                    <b-row> 
                        <b-col cols="12" md="6">
                          <label class="conferencia_dados_label"><b>Bairro: </b> {{form.endereco_apresentante.bairro}}</label>
                        </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="12" md="12" lg="12"><h5 class="mt-5">{{form.dados_divida.especie.code === 'CH' ? 'Endossante' : 'Dados do Sacador'}}</h5><hr></b-col>                      
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6" lg="6">
                        <label  class="conferencia_dados_label"><b>Nome: </b>{{['3',3].includes(form.dados_divida.endosso) ? form.nome_cedente : form.nome_sacador}}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="6">
                        <label  class="conferencia_dados_label float-right"><b>Documento: </b>{{['3',3].includes(form.dados_divida.endosso) ? form.documento_cedente : form.documento_sacador}}</label>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6" lg="6">
                        <label  class="conferencia_dados_label"><b>Email: </b>{{['3',3].includes(form.dados_divida.endosso) ? form.email_cedente : form.email_sacador}}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="6">
                        <label class="conferencia_dados_label float-right"><b>Celular: </b>{{['3',3].includes(form.dados_divida.endosso) ? form.celular_cedente : form.celular_sacador}}</label>
                      </b-col>
                    </b-row>
                    
                    <b-row>                    
                      <b-col cols="12" md="6" lg="6">
                        <label class="conferencia_dados_label"><b>Endereço: </b>{{['3',3].includes(form.dados_divida.endosso) ? form.endereco_cedente.endereco : form.endereco_sacador.endereco}}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="6">
                        <label class="conferencia_dados_label float-right"><b> UF: </b> {{['3',3].includes(form.dados_divida.endosso) ? form.endereco_cedente.uf : form.endereco_sacador.uf}}</label>
                      </b-col>
                    </b-row>

                    <b-row> 
                      <b-col cols="12" md="6" lg="6">
                        <label class="conferencia_dados_label"><b>Cidade: </b> {{['3',3].includes(form.dados_divida.endosso) ? form.endereco_cedente.cidade : form.endereco_sacador.cidade}}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="6">
                        <label class="conferencia_dados_label float-right"><b>CEP: </b>{{['3',3].includes(form.dados_divida.endosso) ? form.endereco_cedente.cep : form.endereco_sacador.cep}}</label>
                      </b-col>
                    </b-row>
                    <b-row> 
                        <b-col cols="12" md="6">
                          <label class="conferencia_dados_label"><b>Bairro: </b> {{['3',3].includes(form.dados_divida.endosso) ? form.endereco_cedente.bairro : form.endereco_sacador.bairro}}</label>
                        </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="12" md="12" lg="12"><h5 class="mt-5">{{form.dados_divida.especie.code === 'CH' ? 'Endossatário' : 'Dados do Cedente'}}</h5><hr></b-col>                      
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6" lg="6">
                        <label  class="conferencia_dados_label"><b>Nome: </b> {{[1,2].includes(form.dados_divida.endosso) ? form.nome_sacador : form.nome_cedente}}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="6">
                        <label  class="conferencia_dados_label float-right"><b>Documento: </b>{{[1,2].includes(form.dados_divida.endosso) ? form.documento_sacador : form.documento_cedente }}</label>
                      </b-col>
                    </b-row>                    
                    <b-row>                    
                      <b-col cols="12" md="6" lg="6">
                        <label class="conferencia_dados_label"><b>Endereço: </b>{{[1,2].includes(form.dados_divida.endosso) ? form.endereco_sacador.endereco : form.endereco_cedente.endereco}}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="6">
                        <label class="conferencia_dados_label float-right"><b>UF: </b>{{[1,2].includes(form.dados_divida.endosso)  ? form.endereco_sacador.uf : form.endereco_cedente.uf}}</label>
                      </b-col>
                    </b-row>
                    <b-row> 
                      <b-col cols="12" md="6">
                        <label class="conferencia_dados_label"><b>Cidade: </b>{{[1,2].includes(form.dados_divida.endosso)  ? form.endereco_sacador.cidade : form.endereco_cedente.cidade}}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="6">
                        <label class="conferencia_dados_label float-right"><b>CEP: </b>{{[1,2].includes(form.dados_divida.endosso)  ? sacador_cep : cedente_cep}}</label>
                      </b-col>
                    </b-row>
                    <b-row> 
                        <b-col cols="12" md="6">
                          <label class="conferencia_dados_label"><b>Bairro: </b>{{[1,2].includes(form.dados_divida.endosso)  ? form.endereco_sacador.bairro : form.endereco_cedente.bairro}}</label>
                        </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="12" md="12" lg="12"><h5 class="mt-5">{{form.dados_divida.especie.code === 'CH' ? 'Emitente' : 'Dados do Devedor'}}</h5><hr></b-col>                      
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6" lg="6">
                        <label  class="conferencia_dados_label"><b>Nome: </b>{{form.nome_devedor}}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="6">
                        <label  class="conferencia_dados_label float-right"><b>Documento: </b>{{form.documento_devedor}}</label>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6">
                        <label  class="conferencia_dados_label"><b>Email: </b>{{form.email_devedor}}</label>
                      </b-col>
                      <b-col cols="12" md="6">
                        <label class="conferencia_dados_label float-right"><b>Contato: </b>{{form.celular_devedor}}</label>
                      </b-col>
                    </b-row>                    
                    <b-row>                    
                      <b-col cols="12" md="6" lg="6">
                        <label class="conferencia_dados_label"><b>Endereço: </b>{{form.endereco_devedor.endereco}}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="6">
                        <label class="conferencia_dados_label float-right"><b>UF: </b>{{form.endereco_devedor.uf}}</label>
                      </b-col>
                    </b-row>
                    <b-row> 
                      <b-col cols="12" md="6">
                        <label class="conferencia_dados_label"><b>Cidade: </b>{{form.endereco_devedor.cidade}}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="3">
                        <label class="conferencia_dados_label float-right"><b>CEP: </b>{{devedor_cep}}</label>
                      </b-col>
                    </b-row>
                    <b-row> 
                        <b-col cols="12" md="6">
                          <label class="conferencia_dados_label"><b>Bairro: </b>{{form.endereco_devedor.bairro}}</label>
                        </b-col>
                    </b-row>

                    <b-row v-if="aCodevedor && aCodevedor.length > 0" v-for="(codevedor, index) in aCodevedor" :key="index">
                      <b-col cols="12" md="12" lg="12"> <h5 class="mt-5">{{form.dados_divida.especie.code === 'CH' ? 'Emitente' : 'Dados do Devedor'}} {{ index + 2 }}</h5><hr> </b-col>

                     
                      <b-col cols="12" md="6" lg="6">
                        <label  class="conferencia_dados_label"><b>Nome: </b>{{ codevedor.nm_nome }}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="6">
                        <label  class="conferencia_dados_label float-right"><b>Documento: </b>{{ codevedor.nm_nr_documento }}</label>
                      </b-col>
                   
                      <b-col cols="12" md="6">
                        <label  class="conferencia_dados_label"><b>Email: </b>{{codevedor.email_devedor}}</label>
                      </b-col>
                      <b-col cols="12" md="6">
                        <label class="conferencia_dados_label float-right"><b>Contato: </b>{{codevedor.celular_devedor}}</label>
                      </b-col>
                                    
                      <b-col cols="12" md="6" lg="6">
                        <label class="conferencia_dados_label"><b>Endereço: </b>{{codevedor.endereco_devedor.nm_endereco_devedor}}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="6">
                        <label class="conferencia_dados_label float-right"><b>UF: </b>{{codevedor.endereco_devedor.sg_uf_devedor}}</label>
                      </b-col>
                    
                      <b-col cols="12" md="6">
                        <label class="conferencia_dados_label"><b>Cidade: </b>{{codevedor.endereco_devedor.nm_cidade_devedor}}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="3">
                        <label class="conferencia_dados_label float-right"><b>CEP: </b>{{codevedor.endereco_devedor.nm_nr_cep_devedor}}</label>
                      </b-col>
                   
                        <b-col cols="12" md="6">
                          <label class="conferencia_dados_label"><b>Bairro: </b>{{codevedor.endereco_devedor.nm_bairro_devedor}}</label>
                        </b-col>
                   
                    </b-row>

                    <b-row>
                      <b-col cols="12" md="12" lg="12"><h5 class="mt-5">{{form.dados_divida.especie.code === 'CH' ? 'Dados do Cheque' : 'Informações da dívida'}}</h5><hr></b-col>                      
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6" lg="6">
                        <label  class="conferencia_dados_label"><b>Numero:</b> {{form.dados_divida.numero}}</label>
                      </b-col>
                      <b-col cols="12" md="6" lg="6">
                        <label  class="conferencia_dados_label float-right"><b>Data emissão:</b> {{form.dados_divida.dt_emissao.substring(8,10)+'/'+form.dados_divida.dt_emissao.substring(5,7) +'/'+form.dados_divida.dt_emissao.substring(0,4)}}</label>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6">
                        <label  class="conferencia_dados_label"><b>Nosso número:</b> {{form.dados_divida.numero}}</label>
                      </b-col>
                      <b-col cols="12" md="6">
                        <label class="conferencia_dados_label float-right"><b>Data vencimento:</b> {{form.dados_divida.dt_vencimento.substring(8,10)+'/'+form.dados_divida.dt_vencimento.substring(5,7)+'/'+form.dados_divida.dt_vencimento.substring(0,4)}}</label>
                      </b-col>
                    </b-row>                    
                    <b-row>                    
                      <b-col cols="12" md="9" lg="6">
                        <label class="conferencia_dados_label"><b>Espécie:</b> {{form.dados_divida.especie.label}}</label>
                      </b-col>
                      <b-col cols="12" md="3" lg="6">
                        <label class="conferencia_dados_label float-right"><b>{{form.dados_divida.especie.code === 'CH' ? 'Valor do cheque:' : 'Valor do título:'}}</b> {{form.dados_divida.valor}}</label>
                      </b-col>
                    </b-row>
                    <b-row> 
                      <b-col cols="12" md="6">
                        <label class="conferencia_dados_label"><b>Endosso:</b> {{endosso_string}}</label>
                      </b-col>
                      <b-col cols="12" md="3" lg="6">
                        <label class="conferencia_dados_label float-right"><b>Valor a protestar:</b> {{form.dados_divida.saldo}}</label>
                      </b-col>
                    </b-row>
                    <b-row> 
                      <b-col cols="12" md="6">
                        <template v-if="(form.dados_divida.aceite === '1')">
                          <label class="conferencia_dados_label"><b>Aceite:</b>  Sim</label>
                        </template>
                        <template v-if="(form.dados_divida.aceite === '2')">
                          <label class="conferencia_dados_label"><b>Aceite:</b>  Não</label>
                        </template>
                        <template v-if="(form.dados_divida.aceite === '3')">
                          <label class="conferencia_dados_label"><b>Aceite:</b>  Sem aceite</label>
                        </template>
                      </b-col>
                      <b-col cols="12" md="3" lg="6" v-if="nm_cidade_praca != '' && ['NP','NPR','CH','CTI'].includes(form.dados_divida.especie.code)">
                        <label class="conferencia_dados_label float-right"><b>Praça de Protesto:</b> {{nm_cidade_praca + ' / ' + form.np_sg_uf}}</label>
                      </b-col>
                    </b-row>
                    <b-row> 
                        <b-col cols="12" md="5">
                          <template v-if="(tipo_de_protesto === '3')">
                            <label class="conferencia_dados_label"><b>Solução Negocial Prévia:</b>  Sim</label>
                          </template>                          
                          <template v-else-if="(tipo_de_protesto === '2')">
                            <label class="conferencia_dados_label"><b>Fins falimentares:</b>  Sim</label>
                          </template>
                          <template v-else>
                            <label class="conferencia_dados_label"><b>Fins falimentares:</b>  Não</label>
                          </template>                          
                        </b-col>
                    </b-row>                    
                  </b-card-text>
                </b-card>
                <br>
                <b-row class="col-12 mb-3 pl-4">
                  <b-form-checkbox
                    id="aceite-declaracao"
                    v-model="aceiteDeclaracao"
                    name="aceite-declaracao"
                    class="col-12 float-right"
                    v-if="isAceiteDeclaracao"
                    >
                    * Declaro, sob as penas da Lei, que garanto a origem e integridade do documento digitalizado, bem como que a
dívida foi regularmente constituída e que os documentos originais ou suas cópias autenticadas, comprobatórios da
causa do título ou do documento de dívida que ensejou a apresentação para protesto, são mantidos em meu poder,
comprometendo-me a exibi-los sempre que exigidos, no lugar e data onde me for determinado, especialmente se
sobrevier sustação judicial de protesto.
                    </b-form-checkbox>
                </b-row>
                <br>
                <b-row class="col-12" >
                  <b-col cols="12" md="12">
                    <b-button variant="danger" class="float-left" @click="tabIndex--">
                      Corrigir Dados
                    </b-button>
                    <b-button
                      variant="primary"
                      class="float-right btn-prosseguir"
                      @click="confirmarDados"
                      :disabled="(!isAceiteDeclaracao || !aceiteDeclaracao) && solicitarProtesto"
                      >
                        Solicitar protesto
                      </b-button>
                  </b-col>
                </b-row>
                </b-tab>
              </b-tabs>
              </div>
            </b-form>
            <br><br><br>
          </b-container>
        </b-col>
      </b-row>
    </div>
      <footersite class="d-none d-xl-block" />
      <footersitemobile class="d-block d-xl-none"/>
  </div>
</template>

<script>
import Header from "../../components/Header";
import API from "../../services/api";
import Menu from "../../template/Menu";
import Serv from "../../services";
import axios from "axios";
// import especies from "../../services/especies_febabran_v43";
import Modal from "../../components/modal/Confmodal";
import codevedor from "../../components/codevedor";
import pdfx from "vue-pdf";
import footersite from "@/components/footersite";
import footersitemobile from "@/components/footersite/index_mobile";

//import Modal from '../../components/modal/Confmodal'

export default {
  components: {
    Header,
    Menu,
    Modal,
    pdfx,
    codevedor,
    footersite,
    footersitemobile
    //Modal,
  },
  data() {
    return {
      emailValidationRegex: /^[a-zA-Z0-9]+([._-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)+$/g,
      desabilita_anexo:false,
      listAceiteDeclaracao: ['DSI', 'DMI','DM', 'LC', 'CAC', 'CAF', 'CAM', 'CI', 'CAR', 'CRC', 'CF', 'CFA', 'CFB', 'CL', 'CLC', 'CM', 'CTI', 'CT', 'CD', 'NP'], // Lista de especies  que precisam de aceite
      breadCrumb:[
        {text: 'Painel',href: "/painel" },
        {text: 'Protesto',disabled: true},
        {text: 'Novo Pedido',active: true}
      ],
      tituloEspecies: {},
      aceiteDeclaracao:false,
      tabIndex: 1,
      desabilidar:false,
      dismissSecs: 5,
      dismissCountDown: 0,
      dismissCountDownDOC: 0,
      dismissCountDownSuc: 0,
      arquivosCertidao: [],
      loading: false,
      show: true,
      procuracao: {},
      termoAceite: "",
      logged: "",
      solicitarProtesto:false,
      bloqueio9430:false,
      erroAnexoSP:false,
      erroEspecieAM:false,
      aCodevedor:[],
      id_codevedor_excluido:0,
      ds_endereco_boleto: null,
      totalCodevedor:0,
      numPages:0,
      aNP:[],
      cidades:[],
      estadosService:[],
      tipo_de_protesto:0,
      travaCedente:false,
      // tipo_protesto:[
      //   {
      //     value: "0",
      //     text: "Comum",
      //   }, {
      //     value: "1",
      //     text: "Fins Fiscais",
      //   },
      //   {
      //     value: "2",
      //     text: "Fins Falimentares",
      //   }
      //   ],
      servico_protesto:null,
      form: {
        // files: [], 
        nome_apresentante: "",
        documento_apresentante: "",
        email_apresentante: "",
        celular_apresentante: "",
        endereco_apresentante: {
          cep: "",
          endereco: "",
          cidade: "",
          cd_uf: "",
          uf: "",
          logradouro:'',
          numero:'',
          complemento:'',
          //ibge:'',
          bairro: "",
        },
        documento_solicitante: "",
        nome_sacador: "",
        documento_sacador: "",
        email_sacador: "",
        celular_sacador: "",
        endereco_sacador: {
          cep: "",
          endereco: "",
          cidade: "",
          cd_uf: "",
          uf: "",
          logradouro:'',
          numero:'',
          complemento:'',
          //ibge:'',
          bairro: "",
        },
        nome_devedor: "",
        documento_devedor: "",
        endereco_devedor: {
          cep: "",
          endereco: "",
          cidade: "",
          cd_uf: "",
          uf: "",
          logradouro:'',
          numero:'',
          complemento:'',
          //ibge:'',
          bairro: "",
        },
        nome_cedente: "",
        documento_cedente: "",
        endereco_cedente: {
          cep: "",
          endereco: "",
          cidade: "",
          cd_uf: "",
          uf: "",
          logradouro:'',
          numero:'',
          complemento:'',
          //ibge:'',
          bairro: "",
        },
        np_cd_uf:'',
        np_sg_uf:'',
        np_cd_ibge:'',
        dados_divida: {
          numero: "",
          nosso_numero: "",
          especie: "",
          justificativa_cheque: "",
          endosso: "3",
          aceite: "2",
          finsFalimentares: "2",
          declaracao_portador: "C",
          saldo: "",
          valor: "",
          dt_emissao: "",
          dt_vencimento: "",
        },
        ic_finalidade_pedido: 0,
        //anexo:'',
      },
      message: "",
      progress: "",
      reader: "",
      servicosEletronicos: [], // Must be an array reference!
      options: [],
      erro: "",
      erroPushRoute:{name:'painel'},
      erroPushMsg:'',
      modalShow: false,
      newWindow: "",
      cd_procuracao: "",
      cdibgeselecionado: "",
      cartorioSelecionado: "",
      municipiosNP:[],
      estados: [],
      municipios: [],
      cartorios: [],
      especies: [],
      endosso: [
        {
          value: "1",
          text: "Mandato",
        },
        {
          value: "2",
          text: "Translativo",
        },
        {
          value: "3",
          text: "Sem Endosso",
        },
      ],
      aceite: [
        {
          value: "1",
          text: "Sim",
        },
        {
          value: "2",
          text: "Não",
        },
        {
          value: "3",
          text: "Sem Aceite",
        },
      ],
      finsFalimentares: [
        {
          value: "1",
          text: "Sim",
        },
        {
          value: "2",
          text: "Não",
        },
      ],
      declaracoes_portador: [
        {
          value: "C",
          text: "Por indicação",
        },
      ],
      optionalValidations:{
        email_devedor:null,
      },
      validations: {

        nome_cedente: null,
        documento_cedente: null,
        endereco_cedente_cep: null,
        endereco_cedente_endereco: null,
        endereco_cedente_endereco_logradouro: null,
        endereco_cedente_endereco_numero: null,
        endereco_cedente_numero: null,
        endereco_cedente_cidade: null,
        endereco_cedente_bairro: null,
        endereco_cedente_uf: null,

        nome_sacador: null,
        documento_sacador: null,
        email_sacador: null,
        celular_sacador: null,
        endereco_sacador_cep: null,
        endereco_sacador_endereco: null,
        endereco_sacador_endereco_logradouro: null,
        endereco_sacador_endereco_numero: null,
        endereco_sacador_numero: null,
        endereco_sacador_cidade: null,
        endereco_sacador_bairro: null,
        endereco_sacador_uf: null,

        nome_devedor: null,
        documento_devedor: null,
        endereco_devedor_cep: null,
        endereco_devedor_endereco: null,
        endereco_devedor_endereco_logradouro: null,
        endereco_devedor_endereco_numero: null,
        endereco_devedor_numero: null,
        endereco_devedor_cidade: null,
        endereco_devedor_bairro: null,
        endereco_devedor_uf: null,

        dados_divida_numero: null,
        dados_divida_nosso_numero: null,
        dados_divida_dt_emissao: null,
        dados_divida_dt_vencimento: null,
        dados_divida_especie: null,
        dados_divida_endosso: null,
        dados_divida_aceite: null,
        dados_divida_fins_falimentares: null,
        dados_divida_valor: null,
        dados_divida_saldo: null,
        dados_divida_anexo: null,
        np_cd_uf:null,
        np_cd_ibge: null,
      },

      sacador_cep: "",
      cedente_cep: "",
      sacador_cep_inicial: "",
      devedor_cep: "",
      erroAnexo: "",
      confirmado: false,
      confirmadoCustas: false,
      pdfConfirma: "",
      mensagemModalConfirma: "",
      maxDate: "",
      minDate: "",
      devedor_uf: "",
      endereco_devedor_uf_disabled: false,
      endereco_devedor_cidade_disabled: false,
      arquivosPermitidos: [
        "application/zip",
        "application/x-zip-compressed",
        "application/pkcs7-signature",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/pdf",
      ],
      especieCTIMunicipioDivergente:false,
      primeiroSelectCTIMunicipio:true,
      anexoObrigatorioProcuracao: ['DMI','DSI'],
      especiesSemAnexo: ['DMI','DSI', 'CBI']
    };
  },
  computed: {
    endosso_string() {
      let endosso = this.form.dados_divida.endosso;
      let string = '';
      if(endosso === '1') return 'Mandato';
      if(endosso === '2') return 'Translativo';
      return 'Sem endosso';
    },
    devedor_ufc() {
      return this.form.endereco_devedor.cd_uf;
    },
    devedor_ibgec() {
      return this.form.endereco_devedor.cidade;
    },
    cedente_ufc() {
      return this.form.endereco_cedente.cd_uf;
    },
    np_cd_ufc(){
      return this.form.np_cd_uf
    },
    np_cd_ibgec(){
      return this.form.np_cd_ibge;
    },
    nm_cidade_praca() {
    const result = this.municipiosNP.find(res => res.value === this.form.np_cd_ibge);
    return result ? result.text : '';
    },

    isAceiteDeclaracao(){
      // if(this.form.dados_divida.especie.code !== undefined && this.form.dados_divida.especie.code !== null)
      // {
      //   return this.tituloEspecies[this.form.dados_divida.especie.code].ic_aceite == 1
      // }
      // else 
      //   return false
      return 1;
    },
    credorPJ(){
      let documento = this.form.documento_sacador
          .replace(".", "")
          .replace(".", "")
          .replace("-", "")
          .replace("/", "");
      return documento > 11;
    },
    devedorPJ(){
      let documento = this.form.documento_devedor
          .replace(".", "")
          .replace(".", "")
          .replace("-", "")
          .replace("/", "");
      return documento > 11;
    },
    tipo_protesto(){
      let tipos = [];
      tipos.push({value:"0",text:"Comum"});
      if(this.credorPJ) tipos.push({value: "1",text: "Fins Fiscais"});
      if(this.devedorPJ) tipos.push({value: "2",text: "Fins Falimentares"});
      //tipos.push({value:"3",text:"Solução Negocial Prévia"});
      return tipos;
    },
    especieTitulo(){
      return this.form.dados_divida.especie;
    },
    isEspecieCTI(){
      return this.especieTitulo.code == "CTI";
    },
    readyMunicipioSelect(){
      return (this.isEspecieCTI && this.municipiosNP.length > 0 && this.primeiroSelectCTIMunicipio);
    }
  },
  watch: {
    tipo_de_protesto:function(val){
       if(val == 0)//comum
       {
        this.form.ic_finalidade_pedido = 0
        this.form.dados_divida.finsFalimentares = 0
       }
      if(val == 1)//LEI 9430
      {
        this.form.ic_finalidade_pedido = 1
        this.form.dados_divida.finsFalimentares = 0
        // alert(1)
      }

      if(val == 2)// fins falimentares
      {
        this.form.ic_finalidade_pedido = 0
        this.form.dados_divida.finsFalimentares = 1
        // this.bloqueio9430 = true;
        // alert(2)
      }

      if(val == 3)// fins falimentares
      {
        this.form.ic_finalidade_pedido = 0
        this.form.dados_divida.finsFalimentares = 3
        // this.bloqueio9430 = true;
        // alert(2)
      }
        
    },
    cedente_cep: function (val) {
      if (val.length == 9)this.BuscarCep(val, "endereco_cedente");
      else if(val.length == 0)this.form.endereco_cedente = {}
    },
    sacador_cep: function (val) {
      if (val.length == 9 && val != this.sacador_cep_inicial)
        this.BuscarCep(val, "endereco_sacador");
    },
    devedor_cep: function (val) {
      if (val.length == 9) this.BuscarCep(val, "endereco_devedor");
    },
    devedor_ufc: function (val) {
      //console.log(dadosUfSelecionada.text)
      let dadosUfSelecionada = this.estados.find((d) => d.value == val);
      this.form.endereco_devedor.cd_uf = val;
      this.form.endereco_devedor.uf = dadosUfSelecionada.text;
      this.form.endereco_devedor.cep = this.devedor_cep;
      if(this.especieTitulo.code == "CTI"){
        this.form.np_cd_uf = val;
        this.primeiroSelectCTIMunicipio = true;
      }
    },
    devedor_ibgec: function (val) {
      if(this.especieTitulo.code == "CTI"){
        this.primeiroSelectCTIMunicipio = true;
      }
    },
    cedente_ufc: function (val) {
      let dadosUfSelecionada = this.estados.find((d) => d.value == val);
      // console.log(dadosUfSelecionada)
      this.form.endereco_cedente.cd_uf = val;
      this.form.endereco_cedente.uf = dadosUfSelecionada.text;
      this.form.endereco_cedente.cep = this.cedente_cep;
    },
    np_cd_ufc: function(newVal, oldVal){
      if(oldVal != newVal && this.form.np_cd_ibge != '') this.form.np_cd_ibge = '';
      this.aNP.cd_uf = newVal;
      let dadosUfSelecionada = this.estados.find((d) => d.value == newVal);
      this.form.np_sg_uf = dadosUfSelecionada.text
      if(newVal == '35') {
        this.erro =
            'Conforme Código de Normas de Serviço da CGSP, cheques e notas promissórias e obrigatório a apresentação do documento de dívida fisicamente no cartório';
          this.$refs["erro"].show();
          this.erroAnexoSP = true;
      }
      else this.erroAnexoSP = false;
      this.buscaCidades(newVal); 
    },
    np_cd_ibgec: function(val){
      this.especieCTIMunicipioDivergente = false;
      if(val != null && val != undefined){
        this.aNP.cd_ibge = val;
        if(this.especieTitulo.code == "CTI" && val != ''){
          let ufDevedor = this.form.endereco_devedor.cd_uf;
          let ufSelecionada = this.form.np_cd_uf;
          if(ufDevedor == ufSelecionada){
            let municipioDevedor = this.form.endereco_devedor.cidade;
            let municipioSelecionado =  this.municipiosNP.find((d) => d.value == val);
            if( !(municipioDevedor == municipioSelecionado.text)){
              this.loading = true;
              setTimeout(() => {
                this.especieCTIMunicipioDivergente = !(municipioDevedor == municipioSelecionado.text);
                this.loading = false;
              }, 2000);
            }
          }
          else {
            this.loading = true;
            setTimeout(() => {
              this.especieCTIMunicipioDivergente = true;
              this.loading = false;
            }, 2000);
          }
        }
        else this.especieCTIMunicipioDivergente = false;
        // if(this.especieCTIMunicipioDivergente){
        //   let municipio = this.municipiosNP.find((d) => d.value == this.form.np_cd_ibge);
        //   // if(municipio != '' && municipio != undefined){
        //   //   this.erro =
        //   //       'Solicito a apresentação a protesto do contrato anexo, na cidade de ' + municipio.text +
        //   //       ' e declaro, ainda, sob as penas da lei que o devedor emitiu declaração expressa e inequívoca para tanto.';
        //   //     this.$refs["erro"].show();
        //   //     this.erroAnexoSP = true;
        //   // }
        // }
      }
    },
    especieTitulo:function(newEspecie, oldEspecie){
      if(newEspecie.code == "CTI"){
        let ufFrom = this.form.np_cd_uf; 
        let ufDevedor = this.form.endereco_devedor.cd_uf;
        if( (ufFrom == undefined || ufFrom == null || ufFrom == '')
            && (ufDevedor != undefined && ufDevedor != null && ufDevedor != '') 
            && this.estados.length > 0){
              this.setUFMunicipio();
        }
      }
    },
    readyMunicipioSelect:function(val){
      if(val){
        this.setMunicipio();
        this.primeiroSelectCTIMunicipio = false;
      }
    },
    especieCTIMunicipioDivergente:function(newVal, oldVal){
      if(newVal){
        let municipio = this.municipiosNP.find((d) => d.value == this.form.np_cd_ibge);
        if(municipio != '' && municipio != undefined){
          this.erro =
              'Solicito a apresentação a protesto do contrato anexo, na cidade de ' + municipio.text +
              ' e declaro, ainda, sob as penas da lei que o devedor emitiu declaração expressa e inequívoca para tanto.';
            this.$refs["declaracaoInequivoca"].show();
        }
      }
    },
  },
  filters: {
    dataHora: function (value) {
      if (value !== "" && value !== undefined && value !== null) {
        let date = new Date(value);
        return date.toLocaleDateString("pt-BR", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });
      }
      return "";
    },
    Celular: function (value) {
      var d = value;
      d = d.replace(/\D/g, "");
      d = d.replace(/^(\d\d)(\d)/g, "($1) $2");
      d = d.replace(/(\d{5})(\d)/, "$1-$2");
      return d;
    },
    Telefone: function (value) {
      var d = value;
      d = d.replace(/\D/g, "");
      d = d.replace(/^(\d\d)(\d)/g, "($1) $2");
      d = d.replace(/(\d{4})(\d)/, "$1-$2");
      return d;
    },
    Moeda: function (v) {
      /*var p = v.indexOf(".");
            v = v.slice(0, (p+3))
            v = v.replace(/\D/g,'');
            v = (v/100).toFixed(2) + '';
            */
      v = v.toString().replace(".", ",");
      v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");
      v = v.replace(/(\d)(\d{3}),/g, "$1.$2,");
      return "R$ " + v;
    },
  },
  mounted() {
    // this.$refs['instabilidade'].show();
  },
  created: function () {
    this.loading = true;
    setTimeout(() => {
      const token = localStorage.getItem('jwtToken');
      API.get(`usuario/dadosbancarios?token=${token}`).then((dadosBancarios) => {
        if (dadosBancarios.data === "") {
          this.blockForm();
          this.loading = false;
          this.erroPushMsg = 'Cadastro do usuário incompleto. Para realizar esse procedimento é preciso fornecer mais informações.'
          this.erroPushRoute = {name: 'cadastroUser'}
          // this.erroPushRoute = {name: 'cadastroUser', params: {dadosLiq: 'liquidacao', dadosBancarios:0}}
          this.$refs['erroPush'].show();
        }
        else {
          API.get('/titulo/especies').then((res) => {
            res.data.response.forEach((especie) => {
              this.especies.push({
                code: especie.sg_especie,
                label: especie.sg_especie + " - " + especie.nm_descricao,
              });
              this.tituloEspecies[especie.sg_especie] = especie;
            })
          });

          let loginComCertifiicado = 
            localStorage.getItem("sg_tipo_documento") && 
            localStorage.getItem("SSL_CLIENT_S_DN_CN") && 
            localStorage.getItem("nm_tipo_certificado") &&
            localStorage.getItem("SSL_CLIENT_S_DN") &&
            localStorage.getItem("SSL_CLIENT_V_START") &&
            localStorage.getItem("SSL_CLIENT_V_END") 
            
          let govLogin = (localStorage.getItem('pxppwiru9') != undefined && localStorage.getItem('pxppwiru9') != null);
          let allowedGov = (govLogin ? ['2','3'].includes(localStorage.getItem("lhwvzhds3")) : false)
          let permissao = false;

           this.getPermicaoServico().then(() => {
              if ( this.servico_protesto == '0' || 
                    (!loginComCertifiicado && !govLogin && localStorage.getItem("usrCpf") != "22055021826")
              ) {
                this.loading = false;
                permissao = false;
                this.$refs["confirmaSemCertificado"].show();
              }
              else {

                if(govLogin){
                  if(!allowedGov) {
                    this.loading = false;
                    this.$refs["confirmaSemCertificado"].show();
                  }
                  else {
                    permissao = allowedGov;
                    this.fTermoAceite();
                    this.buscaEstados();
                    this.loading = false;
                  }
                }
                else{
                  this.$root.isLogged().then(() => {
                        permissao = true;
                        this.logged = true;
                        this.fTermoAceite();
                        this.buscaEstados();
                        this.loading = false;
                      }).catch(() => {
                        permissao = false;
                        this.logged = false;
                        this.loading = false;
                  });
                }
              }
            });
          this.loading = true;

          let now = new Date();

          let dia = now.getDate();
          let mes = now.getMonth();
          let ano = now.getFullYear();

          this.maxDate = ano + "-" + String("00" + (mes + 1)).slice(-2) + "-" + String("00" + (dia - 1)).slice(-2);
          this.minDate = (ano - 30) + "-" + String("00" + (mes + 1)).slice(-2) + "-" + String("00" + (dia - 1)).slice(-2);
          this.loading = false;
        }
      },1500);
    });
  },
  methods: {
    validacoesOpcionais(){
      let validacaoOk = false;
      let validacaoCodevedores = false;
      validacaoOk = this.optionalValidations.email_devedor;
      this.aCodevedor.forEach((element, index) => {
        if(!this.aCodevedor[index].state.email_devedor) return false;
      });

      return validacaoOk;
    },
    validateEmail(event, validationField) {
      let email = event.target.value
      this[validationField] = (email != null && email != '') ? this.emailValidationRegex.test(email) : true
    },
    formataEndereco(tipo){
      let pessoa = this.form['endereco_' + tipo];
      this.form['endereco_' + tipo].endereco = 
              ( pessoa.logradouro + ", " + pessoa.numero + (pessoa.complemento ? " - " + pessoa.complemento : "") ).substr(0, 45);
    },
    updateBloqueio9430(bloqueio){
      this.bloqueio9430 = bloqueio;
    },
    showError(errorMessage){
      this.erro = errorMessage;
      this.$refs["erro"].show();
    },
    redirecionaPainel(){
      this.$router.push({
        name: "painel",
      });
    },
    alteraEndosso(){
      if(['1','2'].includes(this.form.dados_divida.endosso))
      {
        this.travaCedente = false
        this.cedente_cep = this.sacador_cep
      }
      else this.travaCedente = false

    },
    async getPermicaoServico() {
      const token = localStorage.getItem("jwtToken");
      const permissao = await API.post("usuario/getPermicaoServico", { token })
      // console.log(permissao.data[0].servico_protesto);
      this.servico_protesto = permissao.data[0].servico_protesto;
    },
    alteraFinsFalimentares(){
     this.bloqueio9430 = this.form.dados_divida.finsFalimentares == '1' ? true : false
    },
    onChangeEspecie: function (res) {
      if (res.code == "CH") {
        this.erro =
          'Espécie do tipo "Cheque" é necessário  anexar frente verso da imagem ';
        this.$refs["erro"].show();
      }
      // 24/10/2025 - Validação de Procuração para DMI/DSI: PF Solicitante + PJ Sacadora [anexoObrigatorioProcuracao]
      let docSolicitante = this.form.documento_apresentante.replace(/[^0-9]/g, '')
      let docSacador = this.form.documento_sacador.replace(/[^0-9]/g, '')
      if(this.anexoObrigatorioProcuracao.indexOf(res.code) >= 0 && (docSolicitante !== docSacador)){
        if(this.desabilita_anexo){
          this.desabilita_anexo = false
          alert('⚠️ Para espécie selecionada pode ser necessário anexar a Procuração')
        }
      }
      else{
        if (this.especiesSemAnexo.indexOf(res.code) >= 0) {
          if(!this.desabilita_anexo){
            this.erro = 'Espécie não permite anexo';
            this.desabilita_anexo = true
            this.excluirAnexo()
            this.$refs["erro"].show();
          }
        }
        else this.desabilita_anexo = false
      }
      if(this.form.endereco_devedor.cd_uf != '')
      {
        if ((res.code == "DV") && this.form.endereco_devedor.cd_uf == '13') { // AM
            this.erro = 'Espécie não permitida.';
            this.$refs["erro"].show();
            this.erroEspecieAM = true;
        }
        else this.erroEspecieAM = false;
        if(res.code == "NP" && this.form.np_cd_uf == '35')
        {
          this.erro =
            'Conforme Código de Normas de Serviço da CGSP, cheques, confissão de dívida e notas promissórias e obrigatório a apresentação do documento de dívida fisicamente no cartório';
          this.$refs["erro"].show();
          this.erroAnexoSP = true;
        }
        else if ((res.code == "CH" || res.code == "EC" || res.code == "LC" || res.code == "RA")  && this.form.endereco_devedor.cd_uf == '35') {  //SP
           this.erro =
            'Conforme Código de Normas de Serviço da CGSP, cheques, confissão de dívida e notas promissórias e obrigatório a apresentação do documento de dívida fisicamente no cartório';
          this.$refs["erro"].show();
          this.erroAnexoSP = true;
        }

        else this.erroAnexoSP = false;
      }
      // else {
      //   this.erro =
      //       'Informe o endereço do devedor';
      //     this.$refs["erro"].show();
      // }
      if (res.code == "EC" || res.code == "SJ" || res.code == "CJ" || res.code == "CRJ" || res.code == "RJ") {
        this.bloqueio9430 = true;
      }
      else this.bloqueio9430 = false;
    },
    async fTermoAceite() {
      const token = localStorage.getItem("jwtToken");
      const res = await API.post("/usuario/termoaceite/mensagemusuario", {token: token});
      this.erro = res.data.descricao;

      if (res.data.sucesso == 2) {
        this.$router.push({
          name: "cadastroUser",
          params: {
            dadosLiq: "liquidacao",
          },
        });

        //this.$refs['erro'].show();
      }
      if (res.data.sucesso == 0) this.$bvModal.show("modal-conf");
    },
    async buscaEstados() {
      const res = await API.get(`/uf`);
      this.estados = res.data;
      this.estados.push({
        value: "35",
        text: "SP",
      },
      { 
        value: null,
        text: "Selecione",
      }
      );
      this.usuarioLogado();

      //this.loading = false
    },
    async usuarioLogado() {
      const token = localStorage.getItem("jwtToken");
      const res = await API.get("/usuario/logado?token=" + token);
      let campos_para_preencher = ['apresentante', 'sacador', 'cedente']
      campos_para_preencher.forEach((campo) => {
        this.form['nome_' + campo]                 = res.data[0].nm_usuario;
        this.form['documento_' + campo]            = res.data[0].nm_nr_cpfcnpj
        this.form['endereco_' + campo].cep         = this.cep(res.data[0].nm_nr_cep);
        this[campo + '_cep']                       = this.cep(res.data[0].nm_nr_cep);
        this[campo + '_cep_inicial']               = this.cep(res.data[0].nm_nr_cep);
        this.form['endereco_' + campo].endereco    = 
                                ( res.data[0].nm_endereco + " "
                                  + res.data[0].nm_nr_endereco
                                  + (res.data[0].nm_complemento ? " - " + res.data[0].nm_complemento : "") ).substr(0, 45);
        this.form['endereco_' + campo].logradouro  = res.data[0].nm_endereco.substr(0, 30);
        this.form['endereco_' + campo].numero      = res.data[0].nm_nr_endereco.substr(0, 5);
        this.form['endereco_' + campo].complemento = res.data[0].nm_complemento != null ? res.data[0].nm_complemento.substr(0, 10) : "";
        this.form['email_' + campo]                = res.data[0].nm_email;
        this.form['celular_' + campo]              = res.data[0].nm_nr_celular != null ? this.Celular(res.data[0].nm_nr_celular) : "";
        this.form['endereco_' + campo] .cd_uf      = this.estados.find( (d) => d.text == res.data[0].nm_uf ).value;
        this.form['endereco_'+ campo] .uf          = res.data[0].nm_uf;
        this.form['endereco_'+ campo] .cidade      = res.data[0].nm_cidade;
        this.form['endereco_' + campo].bairro      = res.data[0].nm_bairro;
      })


      this.loading = false;
    },
    selecionaUf(iduf) {
      this.buscarMunicipios(iduf);
      this.estadoSelecionado = iduf;
      this.form.comarca_selecionada = "";
      this.form.cartorios_selecionados = [];
      this.cartorios = [];
    },
    async buscarMunicipios(iduf) {
      this.loading = true;
      const res = await API.get(`/municipios?iduf=` + iduf);
      this.municipios = res.data;
      this.loading = false;
      this.form.comarca_selecionada = "";
      this.form.cartorios_selecionados = [];
    },
    async buscarCartorios(cdibge) {
      this.loading = true;
      this.cartorios = [];
      const res = await API.post(`/cartorios/numero`, {
        cdibge: cdibge,
      });
      this.cartorios.push({
        value: "0",
        text: "Todos",
      });
      res.data.forEach((element) => {
        this.cartorios.push({
          value: element.value,
          text: element.text,
        });
      });
      this.form.cartorios_selecionados = [];
      this.loading = false;
    },
    selecionaCartorio(cartorio) {
      if (cartorio[0] == 0) {
        this.cartorios.forEach((element) => {
          this.form.cartorios_selecionados.push(element.value);
          if (this.form.cartorios_selecionados[0] == 0)
            this.form.cartorios_selecionados = [];
        });
      } else this.form.cartorios_selecionados = cartorio;
    },
    documento: function (event) {
      var value = event;
      if (value == null) {
        return "";
      } else {
        let v = value;
        //Remove tudo o que não é dígito
        v = v.replace(/\D/g, "");
        if (v.length < 14) {
          //CPF
          //Coloca um ponto entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um ponto entre o terceiro e o quarto dígitos
          //de novo (para o segundo bloco de números)
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          //Coloca um hífen entre o terceiro e o quarto dígitos
          v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        } else {
          //CNPJ
          //Coloca ponto entre o segundo e o terceiro dígitos
          v = v.replace(/^(\d{2})(\d)/, "$1.$2");
          //Coloca ponto entre o quinto e o sexto dígitos
          v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
          //Coloca uma barra entre o oitavo e o nono dígitos
          v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
          //Coloca um hífen depois do bloco de quatro dígitos
          v = v.replace(/(\d{4})(\d)/, "$1-$2");
        }
        return v;
      }
    },
    Celular: function (value) {
      var d = value;
      d = d.replace(/\D/g, "");
      d = d.replace(/^(\d\d)(\d)/g, "($1) $2");
      d = d.replace(/(\d{5})(\d)/, "$1-$2");
      return d;
    },
    cep: function (event) {
      var d = event;
      if (d != null) {
        d = d.replace(/\D/g, "");
        d = d.replace(/^(\d{5})(\d)/, "$1-$2");
        return d;
      }
    },
    BuscarCep: function (cep, id) {
      var cepl = cep.replace("-", "");
      var self = this;
      try {
        let uf = id + "_uf_disabled";
        let cidade = id + "_cidade_disabled";
        axios
          .get(`https://viacep.com.br/ws/${cepl}/json/`)
          .then((resp) => {
            if (resp.data.erro === true || resp.data.erro === "true") {
              //self.validations[id + `_cep`] = false
              self.validations[id + `_cep`] = true
              self[uf] = false;
              self[cidade] = false;
              self.$set(self.form[id], "cep", "");
              self.$set(self.form[id], "endereco", "");
              self.$set(self.form[id], "logradouro", "");
              self.$set(self.form[id], "complemento", "");
              self.$set(self.form[id], "numero", "");
              self.$set(self.form[id], "bairro", "");
              self.$set(self.form[id], "cidade", "");
              self.$set(self.form[id], "cd_uf", "");
              self.$set(self.form[id], "uf", "");
            } else {
              self[uf] = true;
              self[cidade] = true;
              self.validations[id + `_cep`] = true
              //console.log(id);
              let dadosUfSelecionada = self.estados.find(
                (d) => d.text == resp.data.uf
              );
              self.$set(self.form[id], "cep", cepl);
              // self.$set(self.form[id], "endereco", (resp.data.logradouro + " " + resp.data.complemento).substr(0,45));
              self.$set(self.form[id], "logradouro", resp.data.logradouro.substr(0,30));
              // self.$set(self.form[id], "complemento", resp.data.complemento.substr(0,10));
              if(resp.data.bairro.length > 0)
                self.$set(self.form[id],"bairro",resp.data.bairro.substr(0, 20));
              self.$set(self.form[id],"cidade",resp.data.localidade.substr(0, 20));
              self.$set(self.form[id], "cd_uf", dadosUfSelecionada.value);
              self.$set(self.form[id], "uf", dadosUfSelecionada.text);
              //self.$set(self.form[id],'complemento',resp.data.complemento)
              self.$set(self.form[id], "ibge", resp.data.ibge);
            }
          })
          .catch(() => {
            //console.error('error')
          });
      } catch (error) {
        //console.error('error')
      }
    },
    validarDocumento: function (validation, event) {
      var tipoPessoa = '';
      var documento = '';
      if (event != null) {
        tipoPessoa = event.target.getAttribute("person")
        documento = event.target.value
          .replace(".", "")
          .replace(".", "")
          .replace("-", "")
          .replace("/", "");
        if (documento.length > 11) {
          if (!Serv.validarCNPJ(documento)) this[validation] = false;
          else this[validation] = true;
          this.bloqueio9430 = false;
        } else {
          if (!Serv.validarCPF(documento)) this[validation] = false;
          else this[validation] = true;
          this.bloqueio9430 = true;
        }
        // 24/10/2025 - Validação de Procuração para DMI/DSI: PF Solicitante + PJ Sacadora [anexoObrigatorioProcuracao]
        let docSolicitante = this.form.documento_apresentante.replace(/[^0-9]/g, '')
        let docSacador = this.form.documento_sacador.replace(/[^0-9]/g, '')
        if(this.anexoObrigatorioProcuracao.indexOf(this.form.dados_divida.especie.code) >= 0 && (docSolicitante !== docSacador)){
          if(this.desabilita_anexo){
            this.desabilita_anexo = false
            alert('⚠️ Para espécie selecionada pode ser necessário anexar a Procuração')
          }
        }
        else{
          if (this.especiesSemAnexo.indexOf(this.form.dados_divida.especie.code) >= 0) {
            if(!this.desabilita_anexo){
              this.erro = 'Espécie não permite anexo';
              this.desabilita_anexo = true
              this.excluirAnexo()
              this.$refs["erro"].show();
            }
          }
          else this.desabilita_anexo = false
        }
      } else this[validation] = false;

      let codevedorDuplicado = this.aCodevedor.filter( d => d.nm_nr_documento == event.target.value); 
      //validar não permitir que o Documento do Devedor seja igual ao Documento do Sacador ou do Cedente. 
      if((this.form.documento_sacador != '') &&  (this.form.documento_sacador === this.form.documento_devedor)) {        
        this.showError("Documento do Devedor não poder ser igual ao Documento do Sacador ou Cedente");
        this.$set(this.form, event.target.id, "");
      } else if ((this.form.documento_cedente != '') && (this.form.documento_cedente === this.form.documento_devedor)) {
        this.showError("Documento do Devedor não poder ser igual ao Documento do Sacador ou Cedente");
        this.$set(this.form, event.target.id, "");
      } else if (codevedorDuplicado.length > 0){
        this.showError("Documento do Devedor não poder ser igual ao Documento do Codevedor");
        this.$set(this.form, event.target.id, "");
      }
      if(documento.length == 14) this.consultaDocumentoCNPJ(tipoPessoa, documento);
      else if(tipoPessoa != '') this.consultaDocumento(tipoPessoa);
      
    },
    consultaDocumentoCNPJ(tipoPessoa, documento){
      const token = localStorage.getItem("jwtToken");
      API.post('protesto/empresa', {
        token: token,
        documento: documento
      }).then((res) => {
        if (res.data.status === true) {
          const servico = res.data.servico;
          let cep = servico.cep.substring(0, 5) + '-' + servico.cep.substring(5, 8);

          this.form["nome_" + tipoPessoa] = servico.nome;
          this.form["email_" + tipoPessoa] = servico.email;
          this.form["celular_" + tipoPessoa] = servico.contato;
          this.form["endereco_" + tipoPessoa].endereco = servico.endereco;
          this.form["endereco_" + tipoPessoa].cidade = servico.cidade;
          this.form["endereco_" + tipoPessoa].cep = cep;
          this.form["endereco_" + tipoPessoa].bairro = servico.bairro;
          this.form["endereco_" + tipoPessoa].sg_uf_devedor = servico.estado;
          this.form["endereco_" + tipoPessoa].uf = servico.estado;
          this.form["endereco_" + tipoPessoa].cd_uf = this.estados.find((d) => d.text == servico.estado).value;
          this[tipoPessoa + '_cep'] = this.cep(cep);
        }
      }).catch((error) => {
        console.error('Erro ao consultar CNPJ:', error);
      });
    },
    consultaDocumento(tipoPessoa){
      const token = localStorage.getItem("jwtToken");
      API.post('protesto/consultaDevedor', {
        token:token,
        documento:this.form['documento_' + tipoPessoa]
      }).then( (res) => {
        if(res.data.dados != null)
        {
          let cep                         = res.data.dados.nm_nr_cep_devedor.substring(0,5) + '-' + res.data.dados.nm_nr_cep_devedor.substring(5,8);
          this.form['nome_' + tipoPessoa]                    = res.data.dados.nm_devedor
          this.form['email_' + tipoPessoa]                   = res.data.dados.nm_email_devedor
          this.form['celular_' + tipoPessoa]                 = res.data.dados.nm_nr_celular_devedor
          this.form['endereco_' + tipoPessoa].endereco       = res.data.dados.nm_endereco_devedor
          this.form['endereco_' + tipoPessoa].cidade         = res.data.dados.nm_cidade_devedor
          this.form['endereco_' + tipoPessoa].cep            = this.cep(cep)
          this.form['endereco_' + tipoPessoa].bairro         = res.data.dados.nm_bairro_devedor
          this.form['endereco_' + tipoPessoa].sg_uf_devedor  = res.data.dados.sg_uf_devedor
          this.form['endereco_' + tipoPessoa].uf             = res.data.dados.sg_uf_devedor
          this.form['endereco_' + tipoPessoa].cd_uf          = this.estados.find((d) => d.text == res.data.dados.sg_uf_devedor).value;
          this[tipoPessoa + '_cep']                          = this.cep(cep)
        }
      })
    },
    formataValorMonetario(valor){
        return  valor.replace(/[R$,. ]/g, "")
    },
    valida_data_emissao(data_emissao){
        //valida campo data_emissao, para não ser maior à hoje nem menor que 30 anos atras
        if(data_emissao>=this.minDate && data_emissao<=this.maxDate) return true
        return false
    },
    valida_data_vencimento(data_vencimento, data_emissao){
        //valida campo dt_vencimento, para não ser maior ou igual à hoje
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        var yyyy = today.getFullYear();

        let dataVencSep = data_vencimento.split("-");
        let dataVencSel = new Date(dataVencSep[0], (dataVencSep[1] - 1), dataVencSep[2]).getTime();
        let dataEmiSep = data_emissao.split("-");
        let dataEmiSel = new Date(dataEmiSep[0], (dataEmiSep[1] - 1), dataEmiSep[2]).getTime();
        if (dataVencSel >= new Date(yyyy, (mm - 1), dd).getTime() || dataVencSel<dataEmiSel) return false
        else return true
    },

    valida_campos(){

      this.validations.dados_divida_especie             = this.form.dados_divida.especie != "" 
      this.validations.dados_divida_numero              = this.form.dados_divida.numero != ""
      this.validations.dados_divida_dt_emissao          = this.form.dados_divida.dt_emissao != "" && this.valida_data_emissao(this.form.dados_divida.dt_emissao);
      this.validations.dados_divida_dt_vencimento       = this.form.dados_divida.especie.code === "CJ" ? true : this.form.dados_divida.dt_vencimento !== "" && this.valida_data_vencimento(this.form.dados_divida.dt_vencimento, this.form.dados_divida.dt_emissao);

      // this.validations.dados_divida_dt_vencimento       = this.form.dados_divida.dt_vencimento != "" && this.valida_data_vencimento(this.form.dados_divida.dt_vencimento, this.form.dados_divida.dt_emissao)
      this.validations.dados_divida_valor               = this.formataValorMonetario(this.form.dados_divida.valor) > 0
      this.validations.dados_divida_saldo               = this.formataValorMonetario(this.form.dados_divida.saldo) > 0


      let campos_para_preencher = ['apresentante', 'sacador', 'devedor', 'cedente']
      let doc_sem_formatacao = ''
      let verifica_doc = ''
      this.validations.endereco_cedente_cep = true //regra adicionada, em algum lugar está setando como false

        campos_para_preencher.forEach((campo) => 
        {
          doc_sem_formatacao = this.form['documento_' + campo].replace(/[^0-9]/g, '') 
          verifica_doc       = doc_sem_formatacao.length > 11 ? Serv.validarCNPJ(doc_sem_formatacao) : Serv.validarCPF(doc_sem_formatacao)

          this.validations['nome_' + campo]                     = this.form['nome_' + campo] != "" && this.form['nome_' + campo].length >= 3
          this.validations['documento_' + campo]                = this.form['documento_' + campo] != "" && verifica_doc
          this.validations['endereco_' + campo + '_bairro']     = this.form['endereco_' + campo].bairro != ""
          this.validations['endereco_' + campo + '_cep']        = this.form['endereco_' + campo].cep != "" && this.cep(this.form['endereco_' + campo].cep).length == 9
          this.validations['endereco_' + campo + '_cidade']     = this.form['endereco_' + campo].cidade != ""
          this.validations['endereco_' + campo + '_endereco']   = this.form['endereco_' + campo].endereco != ""
          this.validations['endereco_' + campo + '_endereco_logradouro']  = this.form['endereco_' + campo].logradouro != ""
          this.validations['endereco_' + campo + '_endereco_numero']      = this.form['endereco_' + campo].numero != ""
          this.validations['endereco_' + campo + '_uf']         = this.form['endereco_' + campo].uf != ""
        })


      // 24/10/2025 - Validação de Procuração para DMI/DSI: PF Solicitante + PJ Sacadora [anexoObrigatorioProcuracao]
      let docSolicitante = this.form.documento_apresentante.replace(/[^0-9]/g, '')
      let docSacador = this.form.documento_sacador.replace(/[^0-9]/g, '')
      let especie = this.form.dados_divida.especie.code;
      let isEspecieSemAnexo = this.especiesSemAnexo.indexOf(especie) >= 0;
      let isEspecieProcuracao = this.anexoObrigatorioProcuracao.indexOf(especie) >= 0;
      let isDocSolicitanteDivergenteSacador = (docSolicitante !== docSacador);
      if (isEspecieSemAnexo && !(isEspecieProcuracao && isDocSolicitanteDivergenteSacador)) this.excluirAnexo();

      this.validations.dados_divida_anexo = true;
      // TODO VALIDACAO EMAIL
      //  /^[a-zA-Z0-9]+([._-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)+$/
      this.aCodevedor.forEach((element, index) => {
       this.aCodevedor[index].state.nome        = ! (element.nm_nome == null || element.nm_nome.length < 3)
       this.aCodevedor[index].state.documento   = ! (element.nm_nr_documento == null || element.nm_nr_documento.length < 3)
       this.aCodevedor[index].state.cep         = ! (element.endereco_devedor.nm_nr_cep_devedor == null || element.endereco_devedor.nm_nr_cep_devedor.length < 3)
       this.aCodevedor[index].state.endereco    = ! (element.endereco_devedor.nm_endereco_devedor == null || element.endereco_devedor.nm_endereco_devedor.length < 3)
       this.aCodevedor[index].state.endereco_logradouro    = !(element.endereco_devedor.logradouro == null || element.endereco_devedor.logradouro.length < 3)
       this.aCodevedor[index].state.endereco_numero    = !(element.endereco_devedor.numero == null || element.endereco_devedor.numero.length == "")
       this.aCodevedor[index].state.cidade      = ! (element.endereco_devedor.nm_cidade_devedor == null || element.endereco_devedor.nm_cidade_devedor.length < 3)
       this.aCodevedor[index].state.bairro      = ! (element.endereco_devedor.nm_bairro_devedor == null || element.endereco_devedor.nm_bairro_devedor.length < 3)
       this.aCodevedor[index].state.uf          = ! (element.endereco_devedor.cd_uf == null)
      })

      let self = this
      let retorno_validacao = null

      Object.keys(this.validations).every(function percorre_campos(element) {
        retorno_validacao = self.validations[element] == null || self.validations[element] ? true : false
        return retorno_validacao;
      })

      if (retorno_validacao) {
        const isAnyCodevedorInvalid = this.aCodevedor.some(codevedor => {
          return Object.values(codevedor.state).some(state => state === false);
        });
        if (isAnyCodevedorInvalid) {
          retorno_validacao = false;
        }
      }

      let especies_com_trava_sp = ['CH', 'EC', 'LC', 'RA', 'NP']
      if(especies_com_trava_sp.indexOf(this.form.dados_divida.especie.code) >= 0 && ((this.form.np_cd_uf  == '35') || (this.form.np_cd_uf == null && this.form.endereco_devedor.cd_uf == '35') ))
      {
        retorno_validacao = false
        this.erroAnexoSP = true
      }
      // Validações opcionais (emails devedor e codevedor)
      // let validacoesOpcionais = this.validacoesOpcionais();
      // if(!validacoesOpcionais){
      //   retorno_validacao = false;
      //   return retorno_validacao;
      // }

      return retorno_validacao;
    },
    async gerar() {
      let solicitar = true;

      let erroCodevedores = false
      // solicitar = this.form.dados_divida.especie != "" 


      // Object.keys(this.form).forEach((element) => {
      //   //element, são os objetos filhos do objeto form
      //   let elementoAtual = this.form[element];
      //       // console.log(element, elementoAtual)

      //   if (elementoAtual != undefined &&  elementoAtual != null ) {
      //     Object.keys(elementoAtual).forEach((subElement) => {
      //       //subElement, são os objetos netos do objeto form
      //       let subElementoAtual = this.form[element][subElement];
      //       // console.log(elementoAtual, '=', subElement)
      //       let validationErro = element + "_" + subElement;
      //       // console.log('1 - '+ subElement)
      //       if (subElement == "valor" || subElement == "saldo") {
      //         //se for valor monetario, verifica se é maior que zero
      //         let verificaValor = subElementoAtual.replace(/[R$,. ]/g, ""); //
      //         if (verificaValor <= 0) {
      //           this.validations[validationErro] = false;
      //           solicitar = false;
      //           // console.log("2 - " + subElement )
      //         } else {
      //           this.validations[validationErro] = true;
      //         }
      //       } else if (subElement == "justificativa_cheque") {
      //         if (
      //           this.form.dados_divida.especie.code === "CH" &&
      //           subElementoAtual.length == 0
      //         ) {
      //           this.validations[validationErro] = false;
      //           solicitar = false;
      //           // console.log("3 - " + subElement)
      //         }
      //       } else {
      //         if (subElementoAtual.length <= 0 && subElement !== '$path' && subElementoAtual != 'endereco_cedente') {
      //           //  console.log("4 - " + subElementoAtual)
      //           this.validations[validationErro] = false;
      //           solicitar = false;
      //         } else {
      //           this.validations[validationErro] = true;
      //         }
      //       }
      //     });
      //   }
      //   if (elementoAtual != undefined &&  elementoAtual != null && elementoAtual.length <= 0) {
      //     // console.log(elementoAtual)
      //     if((element == 'np_cd_uf' || element == 'np_cd_ibge' || element == 'np_sg_uf') &&  (this.form.dados_divida.especie.code === "NP" || this.form.dados_divida.especie.code === "NPR") ){
      //       this.validations[element] = false;
      //       solicitar = false;
      //       // console.log(element)
      //     }
      //   } else {
      //     this.validations[element] = true;
      //   }
      // });

      

      // if (this.sacador_cep.length != 9)
      //   this.validations.endereco_sacador_cep = false;
      // else this.validations.endereco_sacador_cep = true;

      // if (this.form.nome_cedente.length < 5)
      // {
      //   this.validations.nome_cedente = false;
      //   solicitar = false;
      // }
      // else this.validations.nome_cedente = true;

      // let docCedenteSemFormatacao = this.form.documento_cedente.replace(/[^0-9]/g, '')
      // if(docCedenteSemFormatacao.length > 11)
      // {
      //    if (!Serv.validarCNPJ(docCedenteSemFormatacao)) {
      //       this.validations.documento_cedente = false;
      //       solicitar = false;
      //     } else this.validations.documento_cedente = true;
      // }else{

      //   if (!Serv.validarCPF(docCedenteSemFormatacao)) {
      //       this.validations.documento_cedente = false;
      //       solicitar = false;
      //     } else this.validations.documento_cedente = true;
      // }

      // if (this.devedor_cep.length != 9)
      //   this.validations.endereco_devedor_cep = false;
      // else this.validations.endereco_devedor_cep = true;

      // let documento_sacador_SemFormatacao = this.form.documento_sacador.replace(/[^0-9]/g, '');

      // if (documento_sacador_SemFormatacao.length > 11) {
      //   if (!Serv.validarCNPJ(documento_sacador_SemFormatacao)) {
      //     this.validations.documento_sacador = false;
      //     solicitar = false;
      //   }
      // } else {
      //   if (!Serv.validarCPF(documento_sacador_SemFormatacao)) {
      //     this.validations.documento_sacador = false;
      //     solicitar = false;
      //   } else this.validations.documento_sacador = true;
      // }

      // let documento_devedor_SemFormatacao = this.form.documento_devedor
      //   .replace(".", "")
      //   .replace(".", "")
      //   .replace("-", "")
      //   .replace("/", "");

      // if (documento_devedor_SemFormatacao.length > 11) {
      //   if (!Serv.validarCNPJ(documento_devedor_SemFormatacao)) {
      //     this.validations.documento_devedor = false;
      //     solicitar = false;
      //   }
      // } else {
      //   if (!Serv.validarCPF(documento_devedor_SemFormatacao)) {
      //     this.validations.documento_devedor = false;
      //     solicitar = false;
      //   } else this.validations.documento_devedor = true;
      // }

      // const dtVencimento = new Date(this.form.dados_divida.dt_vencimento);
      // const dtEmissao = new Date(this.form.dados_divida.dt_emissao);
      // let erroAnexoObrigatorio,
      //   erroDocDevSac,
      //   dtEmiVencInvalida = false;

      //DMI,DSI,CBI, não obrigatório anexo
      // if (
      //   this.form.dados_divida.especie.code != "DMI" &&
      //   this.form.dados_divida.especie.code != "DSI" &&
      //   this.form.dados_divida.especie.code != "CBI" &&
      //   this.form.file.length == 0
      // ) {
      //   erroAnexoObrigatorio = true;
      //   this.validations.dados_divida_anexo = false;
      // } else this.validations.dados_divida_anexo = true;
      // if (this.form.documento_devedor == this.form.documento_sacador)
      //   erroDocDevSac = true;
      // if (dtVencimento.getTime() < 0 || dtEmissao.getTime() < 0)
      //   dtEmiVencInvalida = true;
      // if (
      //   solicitar &&
      //   dtEmissao.getTime() <= dtVencimento.getTime() &&
      //   !this.erroAnexo &&
      //   !erroAnexoObrigatorio &&
      //   !erroDocDevSac &&
      //   !dtEmiVencInvalida &&
      //   !this.erroAnexoSP &&
      //   !this.erroEspecieAM &&
      //   !erroCodevedores
      // ) {
        const dtEmissao = new Date(this.form.dados_divida.dt_emissao);
        let libera_botao_prosseguir = this.valida_campos();
        // console.log(libera_botao_prosseguir)
        if(libera_botao_prosseguir)
        {
        const token = localStorage.getItem("jwtToken");
        const gIdTk = localStorage.getItem("t178w3gm3");
        this.loading = true;
        let anexoEnviado = (this.form.file != null);
        try {
          const res = await API.post(`protesto/solicitarProtesto`, {
            token: token,
            gIdTk: gIdTk,
            dados: this.form,
            aCodevedor:this.aCodevedor,
            confirmado: this.confirmado,
            confirmadoCustas: this.confirmadoCustas,
            nm_tipo_certificado: localStorage.getItem("nm_tipo_certificado"),
            SSL_CLIENT_S_DN_CN: localStorage.getItem("SSL_CLIENT_S_DN_CN"),
            SSL_CLIENT_S_DN: localStorage.getItem("SSL_CLIENT_S_DN"),
            SSL_CLIENT_V_START: localStorage.getItem("SSL_CLIENT_V_START"),
            SSL_CLIENT_V_END: localStorage.getItem("SSL_CLIENT_V_END"),
            anexo_enviado: anexoEnviado
          });
          if (
            res.data.sucesso == 0 ||
            res.data.sucesso == 1 ||
            res.data.sucesso == 2 ||
            res.data.sucesso == 3 ||
            res.data.sucesso == 4
          ) {
            if (res.data.sucesso == 0) {
              this.loading = false;
              this.erro = res.data.descricao;
              this.$refs["erro"].show();
            } else if (res.data.sucesso == 2) this.visualizarPDF(res.data.pdf);
            else if (res.data.sucesso == 3) this.pedidoComBoleto();
            else {
              this.erro = res.data.descricao;
              if (res.data.uf === "SP") {
                this.erro += res.data.cotacao_sp ? ` \nCotação com SP realizada com sucesso.` : ` \nNão foi possível realizar a consulta de cotação com SP. \nPor favor, acesse a lista de pedidos realizados e acione a ação para realizar a cotação com SP.`
              }

              if (this.form.file != null) {

                const fd = new FormData();
                fd.append("file", this.form.file);
                fd.append("token", token);
                fd.append("cd_pedido_protesto", res.data.cd_pedido_protesto);
                try {
                  API.post(`protesto/anexaArquivo`, fd).then((resArquivo) => {
                    if (resArquivo.data.sucesso == 1) {
                      if(resArquivo.data.ds_endereco_boleto != '')this.ds_endereco_boleto = resArquivo.data.ds_endereco_boleto;
                      else this.ds_endereco_boleto = null;
                      if(this.aCodevedor.length <= 0) {
                        //this.loading = false;
                        // próximo tab
                        //alert('vai avançar o tab 02')
                        this.tabIndex++;
                        // alert('02')
                        if (this.aCodevedor.length <= 0) {
                          //this.loading = false;
                          //this.$refs["modalSucesso"].show();
                        }
                        //if(this.ds_endereco_boleto != null)this.$refs["modalBoleto"].show();
                      }
                    }
                  }).catch((error) => {
                    alert('Não foi possível anexar o arquivo ao pedido. Por favor, recarregue a página e preencha o formulário novamente.');
                  });
                } catch (error) {
                  alert('Não foi possível anexar o arquivo ao pedido. Por favor, recarregue a página e preencha o formulário novamente.');
                }

              }
              //console.log(this.aCodevedor.length)
              this.tabIndex++
              //  else {
                setTimeout(() => {
                    this.loading = false;
                    this.$refs["modalSucesso"].show();
                }, 3000);

              // }
             
              this.confirmado = false;
              this.confirmadoCustas = false;

            }
          } else {
            this.erro =
              "Falha ao processar a solicitação, erro ao salvar os dados";
            this.$refs["erro"].show();
          }
        } catch (error) {
          this.loading = false;
          this.erro = "Falha ao processar a solicitação";
          this.$refs["erro"].show();
        }
      } else {
        // if (this.erroAnexo) this.erro = "Arquivo anexado com formato incorreto";
        // else if (erroDocDevSac)
        //   this.erro = "Documento do devedor igual ao do Sacador";
        // else if (dtEmissao.getTime() < 0)
        //   this.erro = "Data de emissão inválida";
        if (this.erroAnexoSP)this.erro = "Conforme Código de Normas de Serviço da CGSP, cheques, confissão de dívida e notas promissórias e obrigatório a apresentação do documento de dívida fisicamente no cartório";
        // else if (this.erroEspecieAM)
        //   this.erro = "Espécie não permitida";        
        // else if (this.erroCodevedores)
        //   this.erro = "Preencha todos os dados ( Codevedores )";        
        // else 
        else this.erro = "Preencha todos os dados";
        this.$refs["erro"].show();
      }
      setTimeout(() => {
          // Após a conclusão da operação, reative o botão
          this.solicitarProtesto = false;
        }, 2000); // Tempo de espera em milissegundos (aqui é de 2 segundos como exemplo)
    },
    incluirTitulos() {
      this.$router.go({
        name: "PedidoProtesto",
      });
    },
    visualizarPedidoProtesto() {
      this.$router.push({
        name: "VisualizarPedidoProtesto",
      });
    },
    moeda: function (event) {
      let valor = String(event.target.value);
      valor = valor.replace(/[\D]+/g, "");
      if (valor != "") {
        valor = valor + "";
        valor = valor.replace(/[\D]+/g, "");
        valor = valor + "";
        valor = valor.replace(/([0-9]{2})$/g, ",$1");
        valor = valor.replace(/(\d)(\d{3}),/g, "$1.$2,");
        valor = valor.replace(/(\d+)(\d{3}.*)/, "$1.$2"); //Coloca o resto dos pontos
        valor = valor.replace(/(\d+)(\d{3}.*)/, "$1.$2");
        valor = valor.replace(/(\d+)(\d{3}.*)/, "$1.$2");
        valor = valor.replace(/(\d+)(\d{3}.*)/, "$1.$2");
      } else {
        valor = "";
      }
      event.target.value = "R$ " + valor;
    },
    async respConfirm(resposta) {
      this.loading = true;
      if (resposta.respostaFinal == "s") {
        const token = localStorage.getItem("jwtToken");
        const res = await API.get(
          "/usuario/termoaceite/aceite/1?token=" + token
        );
        this.loading = false;
        if (res.data.status == "error") alert(res.data.msg);
        else
          this.$router.push({
            name: "cadastroUser",
            params: {
              dadosLiq: "liquidacao",
            },
          });
      } else
        this.$router.push({
          name: "painel",
        });
    },
    updateProgress(event, progress) {
      // evt is an ProgressEvent.
      if (event.lengthComputable) {
        var percentLoaded = Math.round((event.loaded / event.total) * 100);
        // Increase the progress bar length.
        if (percentLoaded < 100) {
          progress.style.width = percentLoaded + '%';
          progress.textContent = percentLoaded + '%';
        }
      }
    },
    handleFileSelect(progress, reader) {
      // Reset progress indicator on new file selection.
      progress.style.width = '0%';
      progress.textContent = '0%';
  
      reader = new FileReader();
      reader.onprogress = this.updateProgress(progress);
      reader.onabort = function() {
        alert('File read cancelled');
      };
      reader.onloadstart = function() {
        document.getElementById('progress_bar').className = 'loading';
      };
      reader.onload = function() {
        // Ensure that the progress bar displays 100% at the end.
        progress.style.width = '90%';
        progress.textContent = '100% CARREGADO';
        //setTimeout("document.getElementById('progress_bar').className='';", 2000);
      }
  
      // Read in the image file as a binary string.
      reader.readAsBinaryString(event.target.files[0]);
    },
    excluirAnexo: function(){
      var reader;
      var element = document.getElementById("progress_bar");
      element.classList.remove("loading");
      element.classList.add("esconder");
      this.$refs["file-input"].reset()
      // document.getElementById('files').addEventListener('change', this.handleFileSelect('0%', ), false);
      this.form.file = null;
    },
    // anexar: function (event) {
    //   //console.log(event.target.files[0].size)
    //   //testte da barra
    //   var reader;
    //   var progress = document.getElementById('percent');

    //   for (let i = 0; i < event.target.files.length; i++) {
    //     if (event.target.files[i].size < 5300000) {
    //       if (this.arquivosPermitidos.indexOf(event.target.files[i].type) >= 0) {
    //         document.getElementById('files').addEventListener('change', this.handleFileSelect(progress, reader), false);
    //         this.form.files.push(event.target.files[i]);
    //         this.erroAnexo = 0;
    //         this.validations.dados_divida_anexo = true;
    //       } else {
    //         this.$refs["file-input"].reset();
    //         this.erroAnexo = 1;
    //         this.form.files = [];
    //         this.erro =
    //           "Arquivo não suportado, é permitido apenas arquivos do tipo PDF, P7S, XLS, ZIP";
    //         this.$refs["erro"].show();
    //         this.validations.dados_divida_anexo = false;
    //       }
    //     } else {
    //       var element = document.getElementById("progress_bar");
    //       element.classList.remove("loading");
    //       element.classList.add("esconder");
    //       this.$refs["file-input"].reset()
    //       this.form.files = [];
    //       this.erro = "Arquivo maior que o suportado, máximo 5 MB";
    //       this.$refs["erro"].show();
    //       this.validations.dados_divida_anexo = false;
    //     }
    //   }

    //   this.desabilidar = false;
    
    // },
    anexar: function (event) {
      //console.log(event.target.files[0].size)
      //testte da barra
      this.desabilidar = true;
      var reader;
      var progress = document.getElementById('percent');

      if (event.target.files[0].size < 5300000) {
        if (this.arquivosPermitidos.indexOf(event.target.files[0].type) >= 0) {
          document.getElementById('files').addEventListener('change', this.handleFileSelect(progress, reader), false);
          this.form.file = event.target.files[0];
          this.erroAnexo = 0;
          this.validations.dados_divida_anexo = true;
        } else {
          this.$refs["file-input"].reset();
          this.erroAnexo = 1;
          this.form.file = "";
          this.erro =
            "Arquivo não suportado, é permitido apenas arquivos do tipo PDF, P7S, XLS, ZIP";
          this.$refs["erro"].show();
          this.validations.dados_divida_anexo = false;
        }
      } else {
        var element = document.getElementById("progress_bar");
        element.classList.remove("loading");
        element.classList.add("esconder");
        this.$refs["file-input"].reset()
        this.form.file = "undefined";
        this.erro = "Arquivo maior que o suportado, máximo 5 MB";
        this.$refs["erro"].show();
        this.validations.dados_divida_anexo = false;
      }
      this.desabilidar = false;
    },
    visualizarPDF(pdf) {
    //   let loadingTask = pdfx.createLoadingTask("data:application/pdf;base64," + pdf);
    //   this.pdfConfirma = loadingTask;
    //   loadingTask.promise.then(pdf => {
    //   this.numPages = pdf.numPages;
		// });
      //console.log(pdfx.createLoadingTask(pdf))
      this.tabIndex++
      //this.$refs["modalConfirmaDados"].show();
      this.loading = false;
    },
    pedidoComBoleto() {
      this.pdfConfirma = "";
      this.mensagemModalConfirma =
        "Está solicitação gerará custas cartorárias para pagamento, deseja prosseguir com a solicitação?";
      this.tabIndex++
      //this.$refs["modalConfirmaDados"].show();
      this.loading = false;
    },
    confirmarDados: function () {
      this.solicitarProtesto = true
      if(this.aceiteDeclaracao){
        if (this.pdfConfirma != null) this.confirmado = true;
        if (this.mensagemModalConfirma.length > 0) this.confirmadoCustas = true;
        this.gerar();
      }
    },
    corrigirDados: function () {
      this.confirmado = false;
      this.confirmadoCustas = true;
      this.$refs["modalConfirmaDados"].hide();
      //this.gerar();
    },
    corrigirDados9430: function () {
      this.confirmado = false;
      this.confirmadoCustas = true;
      this.$refs["modalConfirmaDados9430"].hide();
      //this.gerar();
    },
    confirmarDados9430: function () {
      this.$refs["modalConfirmaDados9430"].hide();
      this.gerar();
    },
    preencheNossoNumero(){
      let self = this
      setTimeout(function (){
        self.form.dados_divida.nosso_numero = self.form.dados_divida.numero
      }, 1)
      
    },
    exibeModalPergunta(){
      let self = this
      setTimeout(function (){
      if(self.form.ic_finalidade_pedido)
      {
        self.pdfConfirma = "";
        self.mensagemModalConfirma =
          "Protesto solicitados para Fins do Art. 9A da Lei 9430/96, com PAGAMENTO ANTECIPADO DAS CUSTAS AO CARTORIO, deseja continuar ? <p><br> Se você for pessoa jurídica tributada com base no lucro real, e desejar registrar como perda este crédito, conforme o art. 9º-A da Lei 9.430/96, selecione esta opção.</p> <br><p>Essa ação irá atualizar o campo <b>Fins Falimentares</b> para o valor <b>Não</b></p>";
        self.$refs["modalConfirmaDados9430"].show();
        self.form.dados_divida.finsFalimentares = 2
        self.loading = false;
      }
    }, 1)
    },
    adicionarCodevedor(){
      this.totalCodevedor++;
      let numeroAleatorio = Math.round(Math.random() * 9);
      
      while(!this.verificaExistenciaNumeroAleatorio(numeroAleatorio))numeroAleatorio = Math.floor(Math.random() * 9) + 1;
      let id_codevedor = numeroAleatorio
     
      this.aCodevedor.push({
        id_codevedor: id_codevedor,
        nm_nome: "",
        nm_nr_documento: "",
        endereco_devedor: {
          nm_nr_cep_devedor: "",
          nm_endereco_devedor: "",
          nm_cidade_devedor: "",
          cd_uf: "",
          sg_uf_devedor: "",
          //complemento:'',
          //ibge:'',
          nm_bairro_devedor: "",
      },
      state:{
        nome:null,
        documento:null,
        cep:null,
        endereco:null,
        cidade:null,
        bairro:null,
        uf:null,
        email_devedor:null
      }
      })
    },
    removerCodevedor(res){
      if(res){
        this.id_codevedor_excluido = res.id_codevedor
        this.totalCodevedor--;
      }
      // console.log(res)
    },
    attCodevedores(res){
      this.aCodevedor = res.codevedores
    },
    verificaExistenciaNumeroAleatorio(numero){
      return this.aCodevedor.filter( d => d.id_codevedor == numero).length>0 ? false : true;
    },
    async buscaCidades(iduf){
      let self = this
      this.loading = true
      const res = await API.get(`/municipios?iduf=` + iduf)
      let municipiosNP = []
      res.data.forEach((element) => {
        municipiosNP.push({
          value: element.value,
          text: element.text,
          label: element.text,
        });
      });
      // this.municipios = res.data;
      this.municipiosNP = municipiosNP;
      this.loading = false
            
    },
    setUFMunicipio(){
      this.loading = true;
      let ufDevedor = this.form.endereco_devedor.cd_uf;
      let ufSelecionada = this.estados.find((d) => d.value == ufDevedor);
      this.form.np_cd_uf = ufSelecionada.value;
      this.loading = false;
    },
    setMunicipio(){
      this.loading = true;
      let municipioDevedor = this.form.endereco_devedor.cidade;
      let municipioSelecionado = this.municipiosNP.find((d) => d.text == municipioDevedor);
      // console.log(municipioSelecionado)
      this.form.np_cd_ibge = municipioSelecionado != undefined ? municipioSelecionado.value : '';
      this.loading = false;
    },
    isFieldSet(value){
      return (value != undefined && value != '' && value != null)
    },
    confirmarMunicipioDeclaracao(resp){
      this.$refs["declaracaoInequivoca"].hide();
      if(!resp){
        this.setUFMunicipio();
        this.loading = true;
        setTimeout(() => {
          this.primeiroSelectCTIMunicipio = true;
          this.false = true;
        }, 1500);
      }
    },
    confirmaErroPush(){
      this.$router.push(this.erroPushRoute);
      this.$refs['erroPush'].hide();
    },
    respostaModalInstabilidade(){
      this.$refs['instabilidade'].hide();
    },
    blockForm(){
      const form = document.getElementById('frmProcuracao');
      if (form) {
        const elementsToDisable = form.querySelectorAll('input, select, textarea, button, a');
        elementsToDisable.forEach(element => {element.disabled = true;});
      }
    },
  },
};
</script>
<style scoped>
#painel .tab2-protesto h4{font: normal normal 200 20px/30px 'Kanit', sans-serif;}
#painel h5{
  text-align: left;
  font: normal normal 200 20px/30px 'Kanit', sans-serif;
  letter-spacing: -1%;
  color: var(--navbar-gray-color);
}
#painel .btn-prosseguir{width: fit-content;
  padding: 6px 20px;
  height: 49px;
  background: var(--primary-color) 0% 0% no-repeat padding-box;
  border: none;
  border-radius: 40px;
  font: normal normal 300 20px/20px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}
#painel .btn-adicionar-codevedor{
  width: fit-content;
  height: 49px;
  border: none;
  background: var(--primary-color) 0% 0% no-repeat padding-box;
  border-radius: 40px;
  text-align: center;
  font: normal normal 300 20px/15px 'Kanit', sans-serif;
  letter-spacing: -1%;
  color: #FFFFFF;
  padding: 0 30px;
}
#painel .btn-adicionar-codevedor svg{margin-left: 5px;}
#painel .card-header{font: normal normal 200 20px/41px 'Kanit', sans-serif; letter-spacing: -1%;padding: 13px 22px;}
#painel .card-header .infolet{background: var(--primary-color) 0% 0% no-repeat padding-box;border-radius: 100%;font: normal normal 400 16px/20px 'Kanit', sans-serif; letter-spacing: -1%;color: #FFFFFF;padding: 0px 10px 0px 9.5px;left: 5px !important;position: relative;top: -1.5px;}
#painel h4{
  text-align: left;
  font: normal normal 200 20px/27px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: var(--secondary-color);
  margin: 0 !important;
  margin-bottom: 35px !important;
}
#painel hr{
  margin-top: 28px;
    margin-bottom: 17px;
}
#painel .card-text label{
  font: normal normal 200 16px/20px 'Kanit', sans-serif;
  letter-spacing: -1%;
  margin-bottom: 6px;
  margin-top: 12px;
  margin-left: 30px;
}

#painel .card-text label i{
  font: italic normal 200 16px/20px 'Kanit', sans-serif;
}
#painel .card-text input.form-control,
#painel .card-text select.custom-select{
  background: var(--light-gray-color) 0% 0% no-repeat padding-box;
  font: normal normal 300 20px/20px 'Kanit', sans-serif;
  text-align: left;
  letter-spacing: -1%;
  border-radius: 40px;
  border: none;
  height: 49px;
  vertical-align: middle;
  color:var(--secondary-color);
  padding: 0 30px;
}
#painel .card-text select.custom-select{
  cursor: pointer;
}
#painel .card-text .select-arrow-down{
  border-left: 5px solid #597EB5;
  border-top: 5px solid #597EB5;
  border-right: 5px solid transparent;
  border-bottom: 5px solid transparent;
  transform: rotate(225deg);
    width: 9px;
    height: 9px;
    position: absolute;
    bottom: 15px;
    right: 28px;
    cursor: pointer;
}
#painel .card-text input.form-control::placeholder{
color: #A8A8A8;}

#painel .container-pedidoprotesto{
  max-width: 964px;
    margin-left: calc((50vw - 964px / 2 ) - (296px + 5px + 5px + (3.8vw - 5px)));
}
#painel #frmProcuracao h1{
  text-align: left;
  font: normal normal 200 50px/55px 'Kanit', sans-serif;
  letter-spacing: -1%;
  color: var(--secondary-color);
  margin-top: 37px !important;
  margin-bottom: 25px !important;
}
    
#painel .tab2-protesto label{font: normal normal 200 16px/20px 'Kanit', sans-serif;}





#wrapper-spinner {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: calc(100% - 80px);
}
#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}
#painel {
  position: fixed;
  width: 100%;
  left: 0px;
  bottom: 0px;
  padding-top: 0px;
  height: calc(100% - 80px);
  overflow-x: hidden;
  border-top: 1px solid #f1f1f1;
}
.lista-certidoes {
  color: #000;
}
.lista-certidoes b {
  font-size: 0.85rem;
  color: var(--main-azul);
}

a {
  color: #555;
}
.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
#loading-solicitante {
  vertical-align: 0;
  margin-left: -21px;
}
.load {
  top: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.spin {
  background: #fff;
  height: 80px;
  width: 80px;
  border-radius: 50vh;
  border-color: #209cee;
  border-top: 5px solid #209cee;
  animation: loading 3s linear infinite;
}
.loading {
  position: relative;
  color: #000;
  display: block !important;
  width: 100%;
}
@keyframes loading {
  100% {
    transform: rotate(360deg);
  }
}
.bold {
  font-weight: bold;
}

.esconder {
  display: none;
}
.mensagemErro {
  color: red;
}
#cabecalho {
  z-index: 0 !important;
}

#progress_bar {
  margin: 10px 0;
  padding: 3px;
  /* border: 1px solid #000; */
  font-size: 14px;
  clear: both;
  opacity: 0;
  -moz-transition: opacity 1s linear;
  -o-transition: opacity 1s linear;
  -webkit-transition: opacity 1s linear;
}
#progress_bar.loading {
  opacity: 1.0;
}
#progress_bar .percent {
  background-color: #10cf76;
  height: auto;
  width: 0;
}

.espaco-menu{width: calc(296px + 5px + 5px);flex: unset;margin-left: calc(3.8vw - 5px);}
/* #painel > .row{justify-content: space-between;} */

#painel{scrollbar-width:none;}
#painel::-webkit-scrollbar{display:none;}
#painel h1 {text-align: left;font: normal normal bold 30px/41px 'Kanit', sans-serif; letter-spacing: 0px;color: #597EB5;margin-bottom: 22px;}
#painelcontainerfluid{margin-top: 37px;}
@media (max-width:1600px) and (min-width:1400px){
  .espaco-menu{margin-left: calc(20px - 5px) !important;}  
  #painelcontainerfluid{padding-right: 20px !important;}
}
@media (max-width:1399px) and (min-width:1200px){
  .espaco-menu{margin-left: calc(10px - 5px) !important;}
  #painelcontainerfluid{padding-right: 10px !important;}
}
@media (max-width:1199px){
  #painel {padding:0 17px;}
  #painel > .row{
    width: 100%;
    /* max-width: none; */
    margin: 0 !important;
    padding: 0px !important;
    margin-bottom: 70px !important;
    /* margin-left: -17px !important; */
    max-width: 100%;
    margin-left: 0px !important;
  }
  .col-lg-9{max-width: none;flex: 1 1 100%;padding: 0;}
  #painelcontainerfluid{padding:0px !important;}
}
@media (max-width:1700px) and (min-width:1300px){
  #painel .container-pedidoprotesto{margin-left: 1vw;}
}
@media (max-width:1300px) and (min-width:1200px){
  #painel .container-pedidoprotesto{
    margin-left: 310px;
    max-width: calc(100vw - 310px);}
}
@media (max-width:1199px) {
  #painel .container-pedidoprotesto {
    margin: 0 auto !important;
    max-width: calc(100vw - 20px);
  }
}
select[disabled="disabled"]{
  cursor: not-allowed !important;
}
.breadcrumb{margin-left: 0px;background: unset;}
.breadcrumb a, .breadcrumb span, .breadcrumb-item + .breadcrumb-item::before{font: normal normal 200 16px/20px 'Kanit', sans-serif;}
.breadcrumb-item + .breadcrumb-item::before{float:unset;}
.breadcrumb a{color:var(--primary-color);}
.breadcrumb-item + .breadcrumb-item::before{color:var(--primary-color);}
.breadcrumb span{color:var(--secondary-color);}
.breadcrumb a.disabled{text-decoration:none;cursor:default;}
.btn-voltar {display: flex;align-items: center;margin-left: auto;letter-spacing: 0px;text-decoration: none;justify-content: flex-end !important;margin-bottom: 20px;}
.btn-voltar img{width: 20px;height: 20px;margin-left: 6px;}

</style>
